(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8957],{

/***/ 36916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ PropertyCard; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/helpers/currencyHelpers.mjs
var currencyHelpers = __webpack_require__(97166);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/marketplace/PropertyCard/PropertyCard.mjs
function cov_2hvthg5jk2() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/PropertyCard.tsx";
    var hash = "e7cc4efcf932e0be8f30eddefe086b5019605309";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/PropertyCard.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 21,
                    column: 57
                },
                end: {
                    line: 121,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 35,
                    column: 2
                },
                end: {
                    line: 120,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 21,
                        column: 57
                    },
                    end: {
                        line: 21,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 6
                    },
                    end: {
                        line: 121,
                        column: 1
                    }
                },
                line: 34
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 50,
                        column: 11
                    },
                    end: {
                        line: 54,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 50,
                            column: 11
                        },
                        end: {
                            line: 50,
                            column: 16
                        }
                    },
                    {
                        start: {
                            line: 51,
                            column: 12
                        },
                        end: {
                            line: 53,
                            column: 19
                        }
                    }
                ],
                line: 50
            },
            "1": {
                loc: {
                    start: {
                        line: 55,
                        column: 11
                    },
                    end: {
                        line: 59,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 55,
                            column: 11
                        },
                        end: {
                            line: 55,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 56,
                            column: 12
                        },
                        end: {
                            line: 58,
                            column: 19
                        }
                    }
                ],
                line: 55
            },
            "2": {
                loc: {
                    start: {
                        line: 61,
                        column: 9
                    },
                    end: {
                        line: 72,
                        column: 9
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 61,
                            column: 9
                        },
                        end: {
                            line: 61,
                            column: 24
                        }
                    },
                    {
                        start: {
                            line: 62,
                            column: 10
                        },
                        end: {
                            line: 71,
                            column: 16
                        }
                    }
                ],
                line: 61
            },
            "3": {
                loc: {
                    start: {
                        line: 64,
                        column: 27
                    },
                    end: {
                        line: 64,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 64,
                            column: 27
                        },
                        end: {
                            line: 64,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 64,
                            column: 41
                        },
                        end: {
                            line: 64,
                            column: 46
                        }
                    }
                ],
                line: 64
            },
            "4": {
                loc: {
                    start: {
                        line: 77,
                        column: 13
                    },
                    end: {
                        line: 77,
                        column: 34
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 77,
                            column: 13
                        },
                        end: {
                            line: 77,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 77,
                            column: 21
                        },
                        end: {
                            line: 77,
                            column: 34
                        }
                    }
                ],
                line: 77
            },
            "5": {
                loc: {
                    start: {
                        line: 79,
                        column: 11
                    },
                    end: {
                        line: 88,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 79,
                            column: 11
                        },
                        end: {
                            line: 79,
                            column: 16
                        }
                    },
                    {
                        start: {
                            line: 80,
                            column: 12
                        },
                        end: {
                            line: 87,
                            column: 15
                        }
                    }
                ],
                line: 79
            },
            "6": {
                loc: {
                    start: {
                        line: 89,
                        column: 11
                    },
                    end: {
                        line: 98,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 89,
                            column: 11
                        },
                        end: {
                            line: 89,
                            column: 15
                        }
                    },
                    {
                        start: {
                            line: 90,
                            column: 12
                        },
                        end: {
                            line: 97,
                            column: 15
                        }
                    }
                ],
                line: 89
            },
            "7": {
                loc: {
                    start: {
                        line: 99,
                        column: 11
                    },
                    end: {
                        line: 108,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 99,
                            column: 11
                        },
                        end: {
                            line: 99,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 100,
                            column: 12
                        },
                        end: {
                            line: 107,
                            column: 15
                        }
                    }
                ],
                line: 99
            },
            "8": {
                loc: {
                    start: {
                        line: 112,
                        column: 13
                    },
                    end: {
                        line: 112,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 112,
                            column: 13
                        },
                        end: {
                            line: 112,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 112,
                            column: 29
                        },
                        end: {
                            line: 112,
                            column: 48
                        }
                    }
                ],
                line: 112
            },
            "9": {
                loc: {
                    start: {
                        line: 115,
                        column: 13
                    },
                    end: {
                        line: 115,
                        column: 30
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 115,
                            column: 13
                        },
                        end: {
                            line: 115,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 115,
                            column: 21
                        },
                        end: {
                            line: 115,
                            column: 30
                        }
                    }
                ],
                line: 115
            }
        },
        s: {
            "0": 0,
            "1": 0
        },
        f: {
            "0": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "e7cc4efcf932e0be8f30eddefe086b5019605309"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2hvthg5jk2 = function cov_2hvthg5jk2() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2hvthg5jk2();



cov_2hvthg5jk2().s[0]++;
var PropertyCard = function PropertyCard(_ref) {
    var _ref2;
    var beds = _ref.beds, baths = _ref.baths, city = _ref.city, dwellingType = _ref.dwellingType, estimatedMonthlyPayment = _ref.estimatedMonthlyPayment, href = _ref.href, isFavorite = _ref.isFavorite, neighborhood = _ref.neighborhood, onFavoritePress = _ref.onFavoritePress, photoUrl = _ref.photoUrl, price = _ref.price, sqft = _ref.sqft;
    cov_2hvthg5jk2().f[0]++;
    cov_2hvthg5jk2().s[1]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%"
    }, /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: href,
        analyticsName: "marketplace-property-card-image-link"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        mb: "$8x",
        borderRadius: "$8x",
        overflow: "hidden"
    }, /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        alt: "Main view of property",
        borderRadius: "$8x",
        source: {
            uri: photoUrl
        },
        resizeMode: "cover",
        aspectRatio: 16 / 9
    }))), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 8
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline"
    }, (cov_2hvthg5jk2().b[0][0]++, price) && (cov_2hvthg5jk2().b[0][1]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        color: "$contentPrimary",
        typography: "$labelXlarge",
        mr: 4
    }, (0,currencyHelpers/* formatCurrency */.xG)(price))), (cov_2hvthg5jk2().b[1][0]++, estimatedMonthlyPayment) && (cov_2hvthg5jk2().b[1][1]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        color: "$contentTertiary",
        typography: "$bodySmall",
        ml: 4
    }, (0,currencyHelpers/* formatCurrency */.xG)(estimatedMonthlyPayment), "/month est."))), (cov_2hvthg5jk2().b[2][0]++, onFavoritePress) && (cov_2hvthg5jk2().b[2][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        alignSelf: "center",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ react.createElement(IconButton/* FavoriteButton */._6, {
        isFavorited: (_ref2 = (cov_2hvthg5jk2().b[3][0]++, isFavorite)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2hvthg5jk2().b[3][1]++, false),
        analyticsName: "marketplace-property-card-favorite-button",
        onPress: onFavoritePress,
        size: "small",
        variant: "default",
        alignSelf: "center"
    })))), /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: href,
        analyticsName: "marketplace-property-card-info-link"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline",
        width: "100%"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[4][0]++, beds) && (cov_2hvthg5jk2().b[4][1]++, "".concat(beds, " bds"))), (cov_2hvthg5jk2().b[5][0]++, baths) && (cov_2hvthg5jk2().b[5][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, "".concat(baths, " ba")))), (cov_2hvthg5jk2().b[6][0]++, sqft) && (cov_2hvthg5jk2().b[6][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, "".concat(sqft.toLocaleString(), " sqft")))), (cov_2hvthg5jk2().b[7][0]++, dwellingType) && (cov_2hvthg5jk2().b[7][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, dwellingType)))), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        mr: "$1x",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[8][0]++, neighborhood) && (cov_2hvthg5jk2().b[8][1]++, "".concat(neighborhood, ", "))), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        mr: "$1x",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[9][0]++, city) && (cov_2hvthg5jk2().b[9][1]++, "".concat(city))))));
}; //# sourceMappingURL=PropertyCard.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/marketplace/PropertyCard/index.mjs
function cov_hgnyifubm() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts";
    var hash = "883a4eaa8cfc30ef36a7e8ea47d91bd450aaf2b5";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts",
        statementMap: {},
        fnMap: {},
        branchMap: {},
        s: {},
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "883a4eaa8cfc30ef36a7e8ea47d91bd450aaf2b5"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_hgnyifubm = function cov_hgnyifubm() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_hgnyifubm();
 //# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 29434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ PhotoCarousel; },
  "r": function() { return /* binding */ PhotoCarouselAspectRatios; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(53089);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(22805);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(63988);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(64645);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Text/index.js
var Text = __webpack_require__(24404);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/Text.js
var Text_Text = __webpack_require__(35934);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/index.js + 9 modules
var StyleSheet = __webpack_require__(65620);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(20129);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/PhotoCarousel/PhotoCarouselDots.js






var PhotoCarouselDots_image = Components/* tokens.image */.T.image, DOT_HEIGHT = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.active.height), ACTIVE_DOT_WIDTH = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.active.width), INACTIVE_DOT_WIDTH = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.other), DOT_MARGIN = 3, VISIBLE_DOTS = 5, PhotoCarouselDots = function(param) {
    var length = param.length, currentIndex = param.currentIndex;
    var animatedValues = (0,react.useRef)(Array(length).fill(0).map(function() {
        return new Animated/* default.Value */.Z.Value(0);
    }));
    return (0,react.useEffect)(function() {
        animatedValues.current.forEach(function(value, index) {
            Animated/* default.timing */.Z.timing(value, {
                toValue: index === currentIndex ? 1 : 0,
                duration: 300,
                useNativeDriver: !1
            }).start();
        });
    }, [
        currentIndex
    ]), /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        children: function() {
            var start = Math.max(0, Math.min(currentIndex - 2, length - VISIBLE_DOTS)), end = Math.min(start + VISIBLE_DOTS, length);
            return Array(length).fill(0).slice(start, end).map(function(_, index) {
                var realIndex = start + index, width = animatedValues.current[realIndex].interpolate({
                    inputRange: [
                        0,
                        1
                    ],
                    outputRange: [
                        INACTIVE_DOT_WIDTH,
                        ACTIVE_DOT_WIDTH
                    ]
                }), opacity = animatedValues.current[realIndex].interpolate({
                    inputRange: [
                        0,
                        1
                    ],
                    outputRange: [
                        0.5,
                        1
                    ]
                });
                return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    "data-testid": "photo-carousel-dot-".concat(realIndex),
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                        style: [
                            styles.dot,
                            {
                                width: width,
                                opacity: opacity
                            }
                        ]
                    })
                }, realIndex);
            });
        }()
    });
}, styles = StyleSheet/* default.create */.Z.create({
    dot: {
        height: DOT_HEIGHT,
        backgroundColor: "white",
        borderRadius: DOT_HEIGHT / 2,
        marginHorizontal: DOT_MARGIN
    }
});


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/PhotoCarousel/PhotoCarousel.js











var DEFAULT_ASPECT_RATIO = 16 / 9, SQUARE_ASPECT_RATIO = 1 / 1;
var PhotoCarouselAspectRatios = /* @__PURE__ */ function(PhotoCarouselAspectRatios2) {
    return PhotoCarouselAspectRatios2[PhotoCarouselAspectRatios2.DEFAULT = DEFAULT_ASPECT_RATIO] = "DEFAULT", PhotoCarouselAspectRatios2[PhotoCarouselAspectRatios2.SQUARE = SQUARE_ASPECT_RATIO] = "SQUARE", PhotoCarouselAspectRatios2;
}(PhotoCarouselAspectRatios || {});
var PhotoCarousel = function(param) {
    var photos = param.photos, children = param.children, ariaLabel = param.ariaLabel, hideNavigation = param.hideNavigation, _aspectRatio = param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? PhotoCarouselAspectRatios.DEFAULT : _aspectRatio, _height = param.height, height = _height === void 0 ? "100%" : _height, _isRounded = param.isRounded, isRounded = _isRounded === void 0 ? !1 : _isRounded;
    var ref = (0,react.useState)(0), currentImageIndex = ref[0], setCurrentImageIndex = ref[1], ref1 = (0,react.useState)(0), containerWidth = ref1[0], setContainerWidth = ref1[1], ref2 = (0,react.useState)(null), panResponder = ref2[0], setPanResponder = ref2[1], offsetX = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, currentOffset = (0,react.useRef)(0), carouselRef = (0,react.useRef)(null), navigationMessagePosition = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, ref3 = (0,react.useState)(!1), showNavigationMessage = ref3[0], setShowNavigationMessage = ref3[1], useNativeDriver = Platform/* default.OS */.Z.OS !== "web", onLayout = function(event) {
        var width = event.nativeEvent.layout.width;
        setContainerWidth(width);
    };
    (0,react.useEffect)(function() {
        Animated/* default.timing */.Z.timing(navigationMessagePosition, {
            toValue: showNavigationMessage ? -65 : 0,
            duration: 300,
            easing: Easing/* default.ease */.Z.ease,
            useNativeDriver: useNativeDriver
        }).start();
    }, [
        navigationMessagePosition,
        showNavigationMessage,
        useNativeDriver
    ]), (0,react.useEffect)(function() {
        var responder = PanResponder/* default.create */.Z.create({
            onMoveShouldSetPanResponder: function() {
                return !0;
            },
            onPanResponderGrant: function() {
                offsetX.setValue(currentOffset.current);
            },
            onPanResponderMove: function(evt, gestureState) {
                offsetX.setValue(currentOffset.current + gestureState.dx);
            },
            onPanResponderRelease: function(evt, gestureState) {
                var threshold = containerWidth / 7;
                var newIndex = currentImageIndex;
                gestureState.dx > threshold ? newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : currentImageIndex : gestureState.dx < -threshold && (newIndex = currentImageIndex < photos.length - 1 ? currentImageIndex + 1 : currentImageIndex), newIndex !== currentImageIndex ? Animated/* default.timing */.Z.timing(offsetX, {
                    toValue: -newIndex * containerWidth,
                    duration: 300,
                    easing: Easing/* default.linear */.Z.linear,
                    useNativeDriver: useNativeDriver
                }).start(function() {
                    setCurrentImageIndex(newIndex), currentOffset.current = -newIndex * containerWidth;
                }) : Animated/* default.spring */.Z.spring(offsetX, {
                    toValue: currentOffset.current,
                    useNativeDriver: useNativeDriver
                }).start();
            }
        });
        setPanResponder(responder);
    }, [
        containerWidth,
        photos.length,
        offsetX,
        currentImageIndex,
        useNativeDriver
    ]), (0,react.useEffect)(function() {
        offsetX.setValue(-currentImageIndex * containerWidth), currentOffset.current = -currentImageIndex * containerWidth;
    }, [
        currentImageIndex,
        containerWidth,
        offsetX
    ]);
    var renderImages = function() {
        return photos.map(function(photo, index) {
            return index >= currentImageIndex - 2 && index <= currentImageIndex + 2 ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: containerWidth,
                height: "100%",
                "aria-hidden": index !== currentImageIndex,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    source: {
                        uri: photo.url
                    },
                    alt: photo.alt || "Image ".concat(index + 1),
                    width: "100%",
                    height: "100%"
                })
            }, index) : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: containerWidth,
                height: "100%",
                "aria-hidden": !0
            }, index);
        });
    }, handlePrev = (0,react.useCallback)(function() {
        currentImageIndex > 0 && setCurrentImageIndex(currentImageIndex - 1);
    }, [
        currentImageIndex
    ]), handleNext = (0,react.useCallback)(function() {
        currentImageIndex < photos.length - 1 && setCurrentImageIndex(currentImageIndex + 1);
    }, [
        currentImageIndex,
        photos.length
    ]);
    (0,react.useEffect)(function() {
        if (!cjs.isWeb) return;
        var handleKeyDown = function(event) {
            event.key === "ArrowLeft" ? handlePrev() : event.key === "ArrowRight" && handleNext(), showNavigationMessage && setShowNavigationMessage(!1);
        }, carouselContainer = carouselRef.current;
        return carouselContainer === null || carouselContainer === void 0 ? void 0 : carouselContainer.addEventListener("keydown", handleKeyDown), function() {
            carouselContainer === null || carouselContainer === void 0 ? void 0 : carouselContainer.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleNext,
        handlePrev,
        showNavigationMessage
    ]);
    var atStart = currentImageIndex === 0, atEnd = currentImageIndex === photos.length - 1;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        role: "region",
        "aria-label": ariaLabel || "Photo Carousel",
        tabIndex: 0,
        ref: carouselRef,
        onFocus: function(event) {
            document.activeElement === carouselRef.current && event.relatedTarget !== null && (setShowNavigationMessage(!0), setTimeout(function() {
                setShowNavigationMessage(!1);
            }, 3e3));
        },
        "data-testid": "photo-carousel",
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                accessibilityRole: "text",
                accessible: !1,
                style: {
                    position: "absolute",
                    width: 0,
                    height: 0,
                    overflow: "hidden"
                },
                children: [
                    "This is an photo carousel of the property. Swipe left or right to navigate through the photos.",
                    " ",
                    !hideNavigation && "Alternatively, use the next and previous buttons to move between photos."
                ]
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                width: "100%",
                onLayout: onLayout
            }, panResponder && panResponder.panHandlers), {
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    aspectRatio: aspectRatio,
                    width: "100%",
                    position: "relative",
                    overflow: "hidden",
                    height: height,
                    borderTopLeftRadius: isRounded ? "$16x" : void 0,
                    borderTopRightRadius: isRounded ? "$16x" : void 0,
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                            style: {
                                flexDirection: "row",
                                width: containerWidth * photos.length,
                                height: "100%",
                                transform: [
                                    {
                                        translateX: offsetX
                                    }
                                ]
                            },
                            children: renderImages()
                        }),
                        cjs.isWeb && !hideNavigation ? /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                !atStart && /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                    size: "medium",
                                    position: "absolute",
                                    top: "50%",
                                    left: "$10x",
                                    analyticsName: "",
                                    onPress: handlePrev,
                                    "aria-label": "Previous photo",
                                    "data-testid": "chevron-back-button"
                                }),
                                !atEnd && /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronForwardButton */.bB, {
                                    size: "medium",
                                    position: "absolute",
                                    top: "50%",
                                    right: "$10x",
                                    analyticsName: "",
                                    onPress: handleNext,
                                    "aria-label": "Next photo",
                                    "data-testid": "chevron-forward-button"
                                })
                            ]
                        }) : null,
                        children,
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            position: "absolute",
                            bottom: "$10x",
                            width: containerWidth,
                            alignItems: "center",
                            flexDirection: "row",
                            justifyContent: "center",
                            "data-testid": "photo-carousel-dots",
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(PhotoCarouselDots, {
                                length: photos.length,
                                currentIndex: currentImageIndex
                            })
                        }),
                        hideNavigation ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                            style: {
                                position: "absolute",
                                bottom: -30,
                                left: 0,
                                right: 0,
                                justifyContent: "center",
                                flexDirection: "row",
                                transform: [
                                    {
                                        translateY: navigationMessagePosition
                                    }
                                ]
                            },
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Text_Text/* Text */.xv, {
                                backgroundColor: "$backgroundInversePrimary",
                                color: "$backgroundPrimary",
                                paddingHorizontal: "$4x",
                                paddingVertical: "$2x",
                                borderRadius: "$10x",
                                typography: "$bodySmall",
                                opacity: 0.7,
                                children: "Use arrow keys to navigate"
                            })
                        }) : null
                    ]
                })
            }))
        ]
    });
};



/***/ }),

/***/ 53757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Pill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_convertColor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12554);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61274);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46523);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);








var BoxWithRgbaBackground = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.styled)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
    variants: {
        backgroundColorVariant: function(variant) {
            var pillTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.pill */ .T.pill;
            return variant !== "inverse" ? {
                backgroundColor: pillTokens.color.background[variant]
            } : {
                backgroundColor: (0,_helpers_convertColor__WEBPACK_IMPORTED_MODULE_4__/* .getRGBA */ .ls)((0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getTokenValue)(pillTokens.color.background.default, "color"), (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_5__/* .getOpacityTokenValue */ .vs)(pillTokens.opacity.backgroundInverse))
            };
        }
    }
}), Pill = function(_param) {
    var label = _param.label, rounded = _param.rounded, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _weight = _param.weight, weight = _weight === void 0 ? "regularWeight" : _weight, dataTestId = _param["data-testid"], props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "label",
        "rounded",
        "variant",
        "weight",
        "data-testid"
    ]);
    var pillTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.pill */ .T.pill, ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.useProps)(props), _size = ref.size, size = _size === void 0 ? "medium" : _size, sizeToken = size === "xsmall" ? "small" : size;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BoxWithRgbaBackground, {
        alignItems: "center",
        justifyContent: "center",
        backgroundColorVariant: variant,
        borderColor: pillTokens.color.border[variant],
        borderRadius: rounded ? pillTokens.cornerRadius.rounded : pillTokens.cornerRadius[sizeToken],
        borderWidth: pillTokens.borderWidth.default,
        height: size === "xsmall" ? "auto" : pillTokens.size.height[weight]["".concat(sizeToken, "Size")],
        paddingBottom: size === "medium" ? pillTokens.padding.medium.bottom[weight] : pillTokens.padding.small.topBottom[weight],
        paddingHorizontal: pillTokens.padding[sizeToken].rightLeft,
        paddingTop: size === "medium" ? pillTokens.padding.medium.top[weight] : pillTokens.padding.small.topBottom[weight],
        width: "max-content",
        "data-testid": dataTestId,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
            tag: "span",
            typography: size === "xsmall" ? "$bodyXsmall" : pillTokens.typography[weight][size],
            fontWeight: weight === "mediumWeight" ? "$medium" : "$regular",
            color: pillTokens.color.content.label[variant === "black" ? "inverse" : variant],
            children: label
        })
    });
};



/***/ }),

/***/ 73503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ Lightbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__(41682);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(53089);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(64645);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(63988);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/canUseDom/index.js
var canUseDom = __webpack_require__(13145);
;// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AccessibilityInfo/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use client';


function isScreenReaderEnabled() {
  return new Promise((resolve, reject) => {
    resolve(true);
  });
}
var prefersReducedMotionMedia = canUseDom/* default */.Z && typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
function isReduceMotionEnabled() {
  return new Promise((resolve, reject) => {
    resolve(prefersReducedMotionMedia ? prefersReducedMotionMedia.matches : true);
  });
}
function addChangeListener(fn) {
  if (prefersReducedMotionMedia != null) {
    prefersReducedMotionMedia.addEventListener != null ? prefersReducedMotionMedia.addEventListener('change', fn) : prefersReducedMotionMedia.addListener(fn);
  }
}
function removeChangeListener(fn) {
  if (prefersReducedMotionMedia != null) {
    prefersReducedMotionMedia.removeEventListener != null ? prefersReducedMotionMedia.removeEventListener('change', fn) : prefersReducedMotionMedia.removeListener(fn);
  }
}
var handlers = {};
var AccessibilityInfo = {
  /**
   * Query whether a screen reader is currently enabled.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  isScreenReaderEnabled,
  /**
   * Query whether the user prefers reduced motion.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  isReduceMotionEnabled,
  /**
   * Deprecated
   */
  fetch: isScreenReaderEnabled,
  /**
   * Add an event handler. Supported events: reduceMotionChanged
   */
  addEventListener: function addEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      if (!prefersReducedMotionMedia) {
        return;
      }
      var listener = event => {
        handler(event.matches);
      };
      addChangeListener(listener);
      handlers[handler] = listener;
    }
    return {
      remove: () => AccessibilityInfo.removeEventListener(eventName, handler)
    };
  },
  /**
   * Set accessibility focus to a react component.
   */
  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},
  /**
   * Post a string to be announced by the screen reader.
   */
  announceForAccessibility: function announceForAccessibility(announcement) {},
  /**
   * Remove an event handler.
   */
  removeEventListener: function removeEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      var listener = handlers[handler];
      if (!listener || !prefersReducedMotionMedia) {
        return;
      }
      removeChangeListener(listener);
    }
    return;
  }
};
/* harmony default export */ var exports_AccessibilityInfo = (AccessibilityInfo);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/ScrollView/index.js + 1 modules
var ScrollView = __webpack_require__(6765);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/dialog/dist/esm/Dialog.mjs + 45 modules
var Dialog = __webpack_require__(310);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/teams/marketplace/components/Lightbox/helpers.js
var CABINET_QUERY_PARAMS_FOR_LIGHTBOX_PRIMARY = "?preset=3:2-md&presetScale=3/4service=lightbox&dpr=1", CABINET_QUERY_PARAMS_LIGHTBOX_CAROUSEL = "?preset=3:2-sm&presetScale=1/8&service=lightbox&dpr=1";


// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/teams/marketplace/components/Lightbox/Lightbox.js














var Lightbox = function(param) {
    var analyticsName = param.analyticsName, photoUrls = param.photoUrls, isOpen = param.isOpen, handleClose = param.handleClose, mobileTitle = param.mobileTitle, footer = param.footer, selectedPhotoIndex = param.selectedPhotoIndex;
    var ref = (0,useWindowDimensions/* default */.Z)(), windowWidth = ref.width, windowHeight = ref.height, photoRefs = (0,react.useRef)([]), ref1 = (0,react.useState)(selectedPhotoIndex || 0), primaryPhotoIndex = ref1[0], setPrimaryPhotoIndex = ref1[1], containerRef = (0,react.useRef)(null), ref2 = (0,react.useState)(null), panResponder = ref2[0], setPanResponder = ref2[1], ref3 = (0,react.useState)(!1), isLandscape = ref3[0], setIsLandscape = ref3[1], offsetX = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, currentOffset = (0,react.useRef)(0), carouselRef = (0,react.useRef)(null), lastNavigationSource = (0,react.useRef)(null), primaryPhotoRefs = (0,react.useRef)(photoUrls.map(function(_) {
        return /*#__PURE__*/ (0,react.createRef)();
    })), handleOnPress = function(index) {
        setPrimaryPhotoIndex(index);
    };
    (0,react.useEffect)(function() {
        cjs.isClient && Math.abs(window.orientation) === 90 && setIsLandscape(!0);
    }, []), (0,react.useEffect)(function() {
        selectedPhotoIndex != null && setPrimaryPhotoIndex(selectedPhotoIndex);
    }, [
        selectedPhotoIndex
    ]), (0,react.useEffect)(function() {
        var ref;
        var photoItem = photoRefs.current[primaryPhotoIndex];
        photoItem === null || photoItem === void 0 ? void 0 : photoItem.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        }), ((ref = lastNavigationSource.current) === null || ref === void 0 ? void 0 : ref.source) === "keyboard" && !lastNavigationSource.current.keyboardActivated && (photoItem === null || photoItem === void 0 ? void 0 : photoItem.focus());
    }, [
        primaryPhotoIndex
    ]);
    var handleRight = (0,react.useCallback)(function(source) {
        var keyboardActivated = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        var newIndex = primaryPhotoIndex + 1;
        return newIndex >= photoUrls.length && (newIndex = 0), setPrimaryPhotoIndex(newIndex), {
            source: source,
            keyboardActivated: keyboardActivated
        };
    }, [
        primaryPhotoIndex,
        photoUrls.length
    ]), handleLeft = (0,react.useCallback)(function(source) {
        var keyboardActivated = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        var newIndex = primaryPhotoIndex - 1;
        return newIndex < 0 && (newIndex = photoUrls.length - 1), setPrimaryPhotoIndex(newIndex), {
            source: source,
            keyboardActivated: keyboardActivated
        };
    }, [
        primaryPhotoIndex,
        photoUrls.length
    ]);
    (0,react.useEffect)(function() {
        var responder = PanResponder/* default.create */.Z.create({
            onMoveShouldSetPanResponder: function() {
                return !0;
            },
            onPanResponderGrant: function() {
                offsetX.setValue(currentOffset.current);
            },
            onPanResponderMove: function(evt, gestureState) {
                var touches = evt.nativeEvent.touches;
                touches && touches.length < 2 && offsetX.setValue(currentOffset.current + gestureState.dx);
            },
            onPanResponderRelease: function(evt, gestureState) {
                var currentImageIndex = primaryPhotoIndex, threshold = windowWidth / 7;
                var newIndex = currentImageIndex;
                gestureState.dx > threshold ? newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : currentImageIndex : gestureState.dx < -threshold && (newIndex = currentImageIndex < photoUrls.length - 1 ? currentImageIndex + 1 : currentImageIndex), newIndex !== currentImageIndex ? Animated/* default.timing */.Z.timing(offsetX, {
                    toValue: -newIndex * windowWidth,
                    duration: 300,
                    easing: Easing/* default.linear */.Z.linear,
                    useNativeDriver: !cjs.isWeb
                }).start(function() {
                    currentOffset.current = -newIndex * windowWidth, setPrimaryPhotoIndex(newIndex), exports_AccessibilityInfo.announceForAccessibility("Image ".concat(newIndex + 1));
                }) : Animated/* default.spring */.Z.spring(offsetX, {
                    toValue: currentOffset.current,
                    useNativeDriver: !cjs.isWeb
                }).start();
            }
        });
        setPanResponder(responder);
    }, [
        windowWidth,
        offsetX,
        primaryPhotoIndex,
        photoUrls.length
    ]), (0,react.useEffect)(function() {
        offsetX.setValue(-primaryPhotoIndex * windowWidth), currentOffset.current = -primaryPhotoIndex * windowWidth;
    }, [
        windowWidth,
        offsetX,
        primaryPhotoIndex
    ]);
    var handleKeyDownEvents = (0,react.useCallback)(function(e) {
        (0,_instanceof/* default */.Z)(e, KeyboardEvent) && (e.key === "ArrowRight" ? lastNavigationSource.current = handleRight("keyboard") : e.key === "ArrowLeft" ? lastNavigationSource.current = handleLeft("keyboard") : e.key === "Escape" && handleClose());
    }, [
        handleClose,
        handleLeft,
        handleRight
    ]), handleChevronPress = (0,react.useCallback)(function(direction) {
        return function(event) {
            var keyboardActivated = !1;
            "nativeEvent" in event && (0,_instanceof/* default */.Z)(event.nativeEvent, KeyboardEvent) ? keyboardActivated = !0 : event.type === "click" && (keyboardActivated = !1), lastNavigationSource.current = direction === "left" ? handleLeft("button", keyboardActivated) : handleRight("button", keyboardActivated);
        };
    }, [
        handleLeft,
        handleRight
    ]);
    (0,react.useEffect)(function() {
        return cjs.isWeb && document.addEventListener("keydown", handleKeyDownEvents), function() {
            cjs.isWeb && document.removeEventListener("keydown", handleKeyDownEvents);
        };
    }, [
        handleKeyDownEvents
    ]), (0,react.useEffect)(function() {
        windowWidth > windowHeight ? setIsLandscape(!0) : setIsLandscape(!1);
    }, [
        windowHeight,
        windowWidth
    ]);
    var renderImages = function() {
        return photoUrls.map(function(photo, index) {
            return index >= primaryPhotoIndex - 2 && index <= primaryPhotoIndex + 2 ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: windowWidth,
                height: "100%",
                "aria-hidden": index !== primaryPhotoIndex,
                flexGrow: 1,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    alt: "Current primary photograph in lightbox",
                    source: {
                        uri: "".concat(photoUrls[index]).concat(CABINET_QUERY_PARAMS_FOR_LIGHTBOX_PRIMARY)
                    },
                    resizeMode: "contain",
                    height: "100%",
                    width: "100%",
                    mb: "$10x",
                    ref: primaryPhotoRefs.current[index],
                    enableZoom: !0
                })
            }, "main-photos-".concat(index)) : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: windowWidth,
                height: "100%",
                "aria-hidden": !0
            }, "main-photo-empty-".concat(index));
        });
    }, ref4 = (0,cjs.useMedia)(), largerThanSM = ref4.largerThanSM, smallerThanMD = ref4.smallerThanMD;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog */.Vq, {
        modal: !0,
        open: isOpen,
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Portal */.Vq.Portal, {
            children: [
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Overlay */.Vq.Overlay, {
                    animation: "accelerateDecelerateFastest",
                    opacity: 0.5,
                    enterStyle: {
                        opacity: 0
                    },
                    exitStyle: {
                        opacity: 0
                    }
                }, "overlay"),
                /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Content */.Vq.Content, {
                    bordered: !0,
                    elevate: !0,
                    animateOnly: [
                        "transform",
                        "opacity"
                    ],
                    animation: [
                        "accelerateDecelerateFastest",
                        {
                            opacity: {
                                overshootClamping: !0
                            }
                        }
                    ],
                    enterStyle: {
                        x: 0,
                        y: -20,
                        opacity: 0,
                        scale: 0.9
                    },
                    exitStyle: {
                        x: 0,
                        y: 10,
                        opacity: 0,
                        scale: 0.95
                    },
                    height: "100%",
                    width: "100%",
                    backgroundColor: "$backgroundInversePureBlack",
                    flexDirection: "column",
                    $smallerThanMD: {
                        justifyContent: "center"
                    },
                    px: 0,
                    focusStyle: {
                        borderColor: "$backgroundInversePureBlack"
                    },
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Title */.Vq.Title, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            onKeyDown: handleKeyDownEvents,
                            $smallerThanMD: {
                                flexDirection: "row-reverse"
                            },
                            width: "100%",
                            "data-testid": "lightbox-content",
                            mt: isLandscape && !cjs.isWeb ? "$20x" : null,
                            $largerThanSM: {
                                px: "$20x"
                            },
                            px: "$10x",
                            display: "flex",
                            alignItems: "center",
                            mb: "$8x",
                            children: [
                                /* @__PURE__ */ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodyMedium",
                                    color: "$contentInversePrimary",
                                    "data-testid": "photo-count",
                                    width: 64,
                                    $largerThanSM: {
                                        textAlign: "left"
                                    },
                                    textAlign: "right",
                                    children: [
                                        primaryPhotoIndex + 1,
                                        " of ",
                                        photoUrls.length
                                    ]
                                }),
                                /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    flex: 1,
                                    justifyContent: "center",
                                    children: smallerThanMD && mobileTitle
                                }),
                                /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Close */.Vq.Close, {
                                    asChild: !0,
                                    children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                        $smallerThanMD: {
                                            width: "$64x"
                                        },
                                        children: [
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* CloseButton */.PZ, {
                                                analyticsName: "desktop-".concat(analyticsName, "-close"),
                                                onPress: handleClose,
                                                size: "medium",
                                                variant: "inverse",
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                $largerThanSM: {
                                                    display: "flex"
                                                }
                                            }),
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                                analyticsName: "mobile-".concat(analyticsName, "-close"),
                                                onPress: handleClose,
                                                size: "medium",
                                                variant: "inverse",
                                                $smallerThanMD: {
                                                    display: "flex"
                                                },
                                                $largerThanSM: {
                                                    display: "none"
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(cjs.View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            width: "100%"
                        }, panResponder && panResponder.panHandlers), {
                            ref: carouselRef,
                            "aria-label": "Image Carousel, showing image ".concat(primaryPhotoIndex + 1, " of ").concat(photoUrls.length),
                            flex: 1,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                ref: containerRef,
                                height: "100%",
                                justifyContent: "center",
                                alignContent: "center",
                                aspectRatio: "3/2",
                                "data-testid": "lightbox-swipeable",
                                children: [
                                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                                        style: {
                                            flexDirection: "row",
                                            width: windowWidth * photoUrls.length,
                                            transform: [
                                                {
                                                    translateX: offsetX
                                                }
                                            ],
                                            marginBottom: 5,
                                            flex: 1
                                        },
                                        children: renderImages()
                                    }),
                                    cjs.isWeb && /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                                "data-testid": "lightbox-back-button",
                                                analyticsName: "".concat(analyticsName, "-lightbox-back-button"),
                                                size: "medium",
                                                $largerThanSM: {
                                                    frameSize: "large",
                                                    left: 32
                                                },
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                variant: "inverse",
                                                onPress: handleChevronPress("left"),
                                                position: "absolute",
                                                left: 0,
                                                ml: "$5x",
                                                top: "40%",
                                                display: "flex"
                                            }),
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronForwardButton */.bB, {
                                                "data-testid": "lightbox-forward-button",
                                                analyticsName: "".concat(analyticsName, "-lightbox-forward-button"),
                                                size: "medium",
                                                onPress: handleChevronPress("right"),
                                                $largerThanSM: {
                                                    frameSize: "large",
                                                    right: 32
                                                },
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                variant: "inverse",
                                                position: "absolute",
                                                right: 0,
                                                mr: "$5x",
                                                top: "40%",
                                                display: "flex"
                                            })
                                        ]
                                    }),
                                    largerThanSM && cjs.isWeb && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollView/* default */.Z, {
                                            horizontal: !0,
                                            showsHorizontalScrollIndicator: !1,
                                            children: photoUrls === null || photoUrls === void 0 ? void 0 : photoUrls.map(function(photo, index) {
                                                return /* @__PURE__ */ (0,jsx_runtime.jsx)(CarouselPhoto, {
                                                    handleOnPress: handleOnPress,
                                                    photoUrl: photo,
                                                    index: index,
                                                    primaryPhotoIndex: primaryPhotoIndex,
                                                    isPrimary: index === primaryPhotoIndex,
                                                    photoRefs: photoRefs
                                                }, index);
                                            })
                                        })
                                    }),
                                    cjs.isWeb && largerThanSM && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        p: "$8x",
                                        width: "100%",
                                        children: footer
                                    })
                                ]
                            })
                        }))
                    ]
                }, "content")
            ]
        })
    });
};
Lightbox.displayName = "Lightbox";
var CarouselPhoto = function(param) {
    var handleOnPress = param.handleOnPress, photoUrl = param.photoUrl, index = param.index, isPrimary = param.isPrimary, photoRefs = param.photoRefs;
    var onPress = (0,react.useCallback)(function() {
        handleOnPress(index);
    }, [
        handleOnPress,
        index
    ]), IMG_CONTAINER_HEIGHT = 65, IMG_CONTAINER_WIDTH = 99, CONTAINER_HEIGHT = 73, photo = "".concat(photoUrl).concat(CABINET_QUERY_PARAMS_LIGHTBOX_CAROUSEL), handleRef = function(el) {
        el && photoRefs.current && (photoRefs.current[index] = el);
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(PressableBox/* PressableBox */.K, {
        analyticsName: "lightbox-photo-item-".concat(index),
        "aria-label": "Lightbox carousel photo ".concat(index + 1),
        borderColor: isPrimary ? "$borderTertiary" : "$backgroundInversePureBlack",
        borderWidth: "$2x",
        height: CONTAINER_HEIGHT,
        $smallerThanMD: {
            display: "none"
        },
        onPress: onPress,
        "data-testid": "photo-item-".concat(index),
        px: 0,
        ref: handleRef,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
            alt: "carousel photograph ".concat(index + 1),
            source: {
                uri: photo
            },
            resizeMode: "cover",
            height: IMG_CONTAINER_HEIGHT,
            width: IMG_CONTAINER_WIDTH
        })
    });
};



/***/ }),

/***/ 7609:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 56536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ Themed; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(30236);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 6 modules
var chakra_ui_system_esm = __webpack_require__(24614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/complex/DatePicker/ReactDatesStyles.mjs
var ReactDatesStyles = __webpack_require__(94339);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/bricks.types.mjs
var bricks_types = __webpack_require__(26153);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ArrowLeft.mjs
function cov_14bqjv2qd1() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ArrowLeft.tsx";
  var hash = "9a103ea456f6ec1c0fb8bb318db72b0467449777";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ArrowLeft.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 50
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9a103ea456f6ec1c0fb8bb318db72b0467449777"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_14bqjv2qd1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_14bqjv2qd1();
var Icon = (cov_14bqjv2qd1().s[0]++, {
  name: 'arrow-left',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.8839 4.11612C12.3957 3.62796 11.6043 3.62796 11.1161 4.11612L4.11612 11.1161C3.62796 11.6043 3.62796 12.3957 4.11612 12.8839L11.1161 19.8839C11.6043 20.372 12.3957 20.372 12.8839 19.8839C13.372 19.3957 13.372 18.6043 12.8839 18.1161L8.01777 13.25H19C19.6904 13.25 20.25 12.6904 20.25 12C20.25 11.3096 19.6904 10.75 19 10.75H8.01777L12.8839 5.88388C13.372 5.39573 13.372 4.60427 12.8839 4.11612Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ArrowLeft = (Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ArrowRight.mjs
function cov_21ov5w4h35() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ArrowRight.tsx";
  var hash = "723aa874ea03209f8a44b9c39e6d6fd0f5c29e19";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ArrowRight.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "723aa874ea03209f8a44b9c39e6d6fd0f5c29e19"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_21ov5w4h35 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_21ov5w4h35();
var ArrowRight_Icon = (cov_21ov5w4h35().s[0]++, {
  name: 'arrow-right',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.1161 4.11612C11.6043 3.62796 12.3957 3.62796 12.8839 4.11612L19.8839 11.1161C20.372 11.6043 20.372 12.3957 19.8839 12.8839L12.8839 19.8839C12.3957 20.372 11.6043 20.372 11.1161 19.8839C10.628 19.3957 10.628 18.6043 11.1161 18.1161L15.9822 13.25H5C4.30964 13.25 3.75 12.6904 3.75 12C3.75 11.3096 4.30964 10.75 5 10.75H15.9822L11.1161 5.88388C10.628 5.39573 10.628 4.60427 11.1161 4.11612Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ArrowRight = (ArrowRight_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Avatar.mjs
function cov_kb9zu7jz4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Avatar.tsx";
  var hash = "9392ed7d0dfb0264b6d3a449c77dee76bb51c533";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Avatar.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9392ed7d0dfb0264b6d3a449c77dee76bb51c533"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_kb9zu7jz4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_kb9zu7jz4();
var Avatar_Icon = (cov_kb9zu7jz4().s[0]++, {
  name: 'avatar',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.4697 15.5H9.53051C8.25942 15.5 7.08825 16.1891 6.47096 17.3003L5.24887 19.5H18.7513L17.5292 17.3002C16.9119 16.1891 15.7408 15.5 14.4697 15.5ZM9.53051 13C7.35151 13 5.34378 14.1814 4.28556 16.0861L2.6508 19.0287C1.91021 20.3618 2.87415 22 4.39912 22H19.6011C21.126 22 22.09 20.3618 21.3494 19.0287L19.7146 16.0861C18.6564 14.1814 16.6487 13 14.4697 13H9.53051Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.0001 9.5C13.3808 9.5 14.5001 8.38071 14.5001 7C14.5001 5.61929 13.3808 4.5 12.0001 4.5C10.6194 4.5 9.50009 5.61929 9.50009 7C9.50009 8.38071 10.6194 9.5 12.0001 9.5ZM12.0001 12C14.7615 12 17.0001 9.76142 17.0001 7C17.0001 4.23858 14.7615 2 12.0001 2C9.23866 2 7.00009 4.23858 7.00009 7C7.00009 9.76142 9.23866 12 12.0001 12Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Avatar = (Avatar_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/CenterFocusStrong.mjs
function cov_16km7nxxrm() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/CenterFocusStrong.tsx";
  var hash = "d63325720010d489d4dd37bfcd6df74a3c8af429";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/CenterFocusStrong.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 59
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d63325720010d489d4dd37bfcd6df74a3c8af429"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_16km7nxxrm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_16km7nxxrm();
var CenterFocusStrong_Icon = (cov_16km7nxxrm().s[0]++, {
  name: 'center-focus-strong',
  svg: "<path d=\"M17 12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5Zm-5 3c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm-7 0H3v4c0 1.1.9 2 2 2h4v-2H5v-4ZM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5Zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2Zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var CenterFocusStrong = (CenterFocusStrong_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChatInactive.mjs
function cov_y2oy7onc2() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChatInactive.tsx";
  var hash = "e8694405215aa9ba0e6d2eae76cba18eafb1485f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChatInactive.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e8694405215aa9ba0e6d2eae76cba18eafb1485f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_y2oy7onc2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_y2oy7onc2();
var ChatInactive_Icon = (cov_y2oy7onc2().s[0]++, {
  name: 'chat-inactive',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.3184 15.5L19.5 18.5665V5C19.5 4.72386 19.2761 4.5 19 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V15C4.5 15.2761 4.72386 15.5 5 15.5H15.3184ZM14.5 18L20.4086 22.333C21.0692 22.8174 22 22.3457 22 21.5266V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V15C2 16.6569 3.34315 18 5 18H14.5Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ChatInactive = (ChatInactive_Icon);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Checkmark.mjs
var Checkmark = __webpack_require__(77972);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronDown.mjs
function cov_1lu1rsgtpd() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown.tsx";
  var hash = "70ab844cf3ee04b49a54a20701a1141c5bc163a3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "70ab844cf3ee04b49a54a20701a1141c5bc163a3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1lu1rsgtpd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1lu1rsgtpd();
var ChevronDown_Icon = (cov_1lu1rsgtpd().s[0]++, {
  name: 'chevron-down',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.7808 7.0239C19.3199 7.45516 19.4073 8.24178 18.976 8.78085L12.976 16.2809C12.7388 16.5774 12.3797 16.75 12 16.75C11.6202 16.75 11.2611 16.5774 11.0239 16.2809L5.02387 8.78085C4.59261 8.24178 4.68001 7.45516 5.21909 7.0239C5.75816 6.59264 6.54478 6.68004 6.97604 7.21912L12 13.499L17.0239 7.21912C17.4551 6.68004 18.2417 6.59264 18.7808 7.0239Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ChevronDown = (ChevronDown_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronDown16.mjs
function cov_ghjsw3q5f() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown16.tsx";
  var hash = "b5e06376a9713ee24d1b009d2a369f27545f3c36";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown16.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b5e06376a9713ee24d1b009d2a369f27545f3c36"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ghjsw3q5f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ghjsw3q5f();
var ChevronDown16_Icon = (cov_ghjsw3q5f().s[0]++, {
  name: 'chevron-down-16',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.8839 5.11612C14.372 5.60427 14.372 6.39573 13.8839 6.88388L8.88388 11.8839C8.64946 12.1183 8.33152 12.25 8 12.25C7.66848 12.25 7.35054 12.1183 7.11612 11.8839L2.11612 6.88388C1.62796 6.39573 1.62796 5.60427 2.11612 5.11612C2.60427 4.62796 3.39573 4.62796 3.88388 5.11612L8 9.23223L12.1161 5.11612C12.6043 4.62796 13.3957 4.62796 13.8839 5.11612Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ChevronDown16 = (ChevronDown16_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronLeft.mjs
function cov_1vjsa3ppix() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft.tsx";
  var hash = "632e5e0c3812891ff86b9e96289f50601a68a834";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "632e5e0c3812891ff86b9e96289f50601a68a834"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vjsa3ppix = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vjsa3ppix();
var ChevronLeft_Icon = (cov_1vjsa3ppix().s[0]++, {
  name: 'chevron-left',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_back_ios\" d=\"M8.09035 12L15.623 19.5327C15.8218 19.7314 15.9186 19.9654 15.9134 20.2346C15.9083 20.5038 15.8064 20.7378 15.6076 20.9365C15.4089 21.1352 15.175 21.2346 14.9058 21.2346C14.6365 21.2346 14.4026 21.1352 14.2039 20.9365L6.5327 13.2808C6.3519 13.1 6.21792 12.8974 6.13075 12.6731C6.04358 12.4487 6 12.2244 6 12C6 11.7757 6.04358 11.5513 6.13075 11.3269C6.21793 11.1026 6.35192 10.9 6.5327 10.7193L14.2039 3.0481C14.4026 2.84938 14.6391 2.75258 14.9135 2.7577C15.1878 2.76283 15.4243 2.86476 15.623 3.06348C15.8218 3.26219 15.9211 3.49616 15.9211 3.76538C15.9211 4.03461 15.8218 4.26858 15.623 4.4673L8.09035 12Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ChevronLeft = (ChevronLeft_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronLeft12.mjs
function cov_3rlw38br5() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft12.tsx";
  var hash = "31c54b946507545ca17f20825405833543fad39a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft12.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "31c54b946507545ca17f20825405833543fad39a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_3rlw38br5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_3rlw38br5();
var ChevronLeft12_Icon = (cov_3rlw38br5().s[0]++, {
  name: 'chevron-left-12',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.88388 9.88388C8.39573 10.372 7.60427 10.372 7.11612 9.88388L4.11612 6.88388C3.62796 6.39573 3.62796 5.60427 4.11612 5.11612L7.11612 2.11612C7.60427 1.62796 8.39573 1.62796 8.88388 2.11612C9.37204 2.60427 9.37204 3.39573 8.88388 3.88388L6.76777 6L8.88388 8.11612C9.37204 8.60427 9.37204 9.39573 8.88388 9.88388Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ChevronLeft12 = (ChevronLeft12_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronRight.mjs
function cov_1m4ayordkx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight.tsx";
  var hash = "8bc5d27d1b71da2697b9377c2e1daa79b0844106";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8bc5d27d1b71da2697b9377c2e1daa79b0844106"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1m4ayordkx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1m4ayordkx();
var ChevronRight_Icon = (cov_1m4ayordkx().s[0]++, {
  name: 'chevron-right',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M15.8308 11.9921L8.29809 4.45942C8.09938 4.26071 8.00258 4.02673 8.00772 3.7575C8.01285 3.48828 8.11478 3.25432 8.31349 3.0556C8.51219 2.85688 8.74616 2.75752 9.01539 2.75752C9.28463 2.75752 9.51859 2.85688 9.71729 3.0556L17.3884 10.7114C17.5692 10.8921 17.7032 11.0947 17.7904 11.319C17.8776 11.5434 17.9211 11.7678 17.9211 11.9921C17.9211 12.2165 17.8776 12.4408 17.7904 12.6652C17.7032 12.8896 17.5692 13.0921 17.3884 13.2729L9.71729 20.944C9.51859 21.1427 9.28206 21.2395 9.00769 21.2344C8.73334 21.2293 8.49681 21.1274 8.29809 20.9287C8.09938 20.7299 8.00002 20.496 8.00002 20.2268C8.00002 19.9575 8.09938 19.7235 8.29809 19.5248L15.8308 11.9921Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ChevronRight = (ChevronRight_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronRight12.mjs
function cov_8izfu1rqa() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight12.tsx";
  var hash = "5cee0f12536d99f60c98e47c182e9a67f0e5bb89";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight12.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 56
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5cee0f12536d99f60c98e47c182e9a67f0e5bb89"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_8izfu1rqa = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_8izfu1rqa();
var ChevronRight12_Icon = (cov_8izfu1rqa().s[0]++, {
  name: 'chevron-right-12',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.11612 2.11612C4.60427 1.62796 5.39573 1.62796 5.88388 2.11612L8.88388 5.11612C9.37204 5.60427 9.37204 6.39573 8.88388 6.88388L5.88388 9.88388C5.39573 10.372 4.60427 10.372 4.11612 9.88388C3.62796 9.39573 3.62796 8.60427 4.11612 8.11612L6.23223 6L4.11612 3.88388C3.62796 3.39573 3.62796 2.60427 4.11612 2.11612Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ChevronRight12 = (ChevronRight12_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronUp.mjs
function cov_2anpiq8dkk() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronUp.tsx";
  var hash = "e364c9ca0cb7989854c207ae2332468707d51df0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronUp.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 50
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e364c9ca0cb7989854c207ae2332468707d51df0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2anpiq8dkk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2anpiq8dkk();
var ChevronUp_Icon = (cov_2anpiq8dkk().s[0]++, {
  name: 'chevron-up',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.21918 16.4761C4.6801 16.0448 4.5927 15.2582 5.02396 14.7191L11.024 7.21915C11.2612 6.92263 11.6203 6.75001 12 6.75001C12.3798 6.75001 12.7389 6.92263 12.9761 7.21915L18.9761 14.7191C19.4074 15.2582 19.32 16.0448 18.7809 16.4761C18.2418 16.9074 17.4552 16.82 17.024 16.2809L12 10.001L6.97613 16.2809C6.54487 16.82 5.75825 16.9074 5.21918 16.4761Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ChevronUp = (ChevronUp_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Close.mjs
function cov_kho02a6py() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close.tsx";
  var hash = "1e89307570a95f6cedef1cd412978432b7d6505f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1e89307570a95f6cedef1cd412978432b7d6505f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_kho02a6py = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_kho02a6py();
var Close_Icon = (cov_kho02a6py().s[0]++, {
  name: 'close',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M12 13.0538L6.92689 18.1269C6.78844 18.2654 6.6144 18.3362 6.40479 18.3394C6.19519 18.3426 6.01795 18.2718 5.87309 18.1269C5.7282 17.982 5.65576 17.8064 5.65576 17.6C5.65576 17.3936 5.7282 17.218 5.87309 17.0731L10.9462 12L5.87309 6.92689C5.73462 6.78844 5.66379 6.6144 5.66059 6.40479C5.65737 6.19519 5.7282 6.01795 5.87309 5.87309C6.01795 5.7282 6.19359 5.65576 6.39999 5.65576C6.60639 5.65576 6.78202 5.7282 6.92689 5.87309L12 10.9462L17.0731 5.87309C17.2115 5.73462 17.3856 5.66379 17.5952 5.66059C17.8048 5.65737 17.982 5.7282 18.1269 5.87309C18.2718 6.01795 18.3442 6.19359 18.3442 6.39999C18.3442 6.60639 18.2718 6.78202 18.1269 6.92689L13.0538 12L18.1269 17.0731C18.2654 17.2115 18.3362 17.3856 18.3394 17.5952C18.3426 17.8048 18.2718 17.982 18.1269 18.1269C17.982 18.2718 17.8064 18.3442 17.6 18.3442C17.3936 18.3442 17.218 18.2718 17.0731 18.1269L12 13.0538Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Close = (Close_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Close16.mjs
function cov_rkb62rso3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close16.tsx";
  var hash = "a323f52c1aef9a5062973d317fc7a0b967804b6d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close16.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a323f52c1aef9a5062973d317fc7a0b967804b6d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_rkb62rso3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_rkb62rso3();
var Close16_Icon = (cov_rkb62rso3().s[0]++, {
  name: 'close-16',
  svg: "<path d=\"M10.6515 12.4191C11.1397 12.9072 11.9312 12.9072 12.4193 12.4191C12.9075 11.9309 12.9075 11.1395 12.4193 10.6513L9.76804 8.00003L12.4193 5.34875C12.9075 4.86059 12.9075 4.06914 12.4193 3.58098C11.9312 3.09283 11.1397 3.09283 10.6515 3.58098L8.00027 6.23226L5.34824 3.58023C4.86008 3.09207 4.06863 3.09207 3.58047 3.58023C3.09232 4.06838 3.09232 4.85984 3.58047 5.34799L6.2325 8.00002L3.58048 10.652C3.09232 11.1402 3.09232 11.9317 3.58048 12.4198C4.06863 12.908 4.86009 12.908 5.34824 12.4198L8.00027 9.76779L10.6515 12.4191Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Close16 = (Close16_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ContactPhone.mjs
function cov_1s95e2dh2v() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ContactPhone.tsx";
  var hash = "f1d7e1eba24e4f3a7dd0ea8c7f236e5247de5864";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ContactPhone.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f1d7e1eba24e4f3a7dd0ea8c7f236e5247de5864"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1s95e2dh2v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1s95e2dh2v();
var ContactPhone_Icon = (cov_1s95e2dh2v().s[0]++, {
  name: 'contact-phone',
  svg: "<path d=\"M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2Zm0 16H2V5h20v14Zm-2.99-1.01L21 16l-1.51-2h-1.64c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2h1.64L21 8l-1.99-1.99A7.474 7.474 0 0 0 16.28 10c-.18.64-.28 1.31-.28 2s.1 1.36.28 2a7.512 7.512 0 0 0 2.73 3.99ZM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3Zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41ZM5.48 16c.74-.5 2.22-1 3.52-1 1.3 0 2.77.49 3.52 1H5.48Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var ContactPhone = (ContactPhone_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Date.mjs
function cov_aq0fs0sz() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Date.tsx";
  var hash = "26ce8bb8896a4579fac55d105d97ed2a1070cd97";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Date.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "26ce8bb8896a4579fac55d105d97ed2a1070cd97"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_aq0fs0sz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_aq0fs0sz();
var Date_Icon = (cov_aq0fs0sz().s[0]++, {
  name: 'date',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.75 3C8.75 2.30964 8.19036 1.75 7.5 1.75C6.80964 1.75 6.25 2.30964 6.25 3V5H5C3.34315 5 2 6.34315 2 8V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V8C22 6.34315 20.6569 5 19 5H17.75V3C17.75 2.30964 17.1904 1.75 16.5 1.75C15.8096 1.75 15.25 2.30964 15.25 3V5H8.75V3ZM6.25 7.5V8.5C6.25 9.19036 6.80964 9.75 7.5 9.75C8.19036 9.75 8.75 9.19036 8.75 8.5V7.5H15.25V8.5C15.25 9.19036 15.8096 9.75 16.5 9.75C17.1904 9.75 17.75 9.19036 17.75 8.5V7.5H19C19.2761 7.5 19.5 7.72386 19.5 8V10.75H4.5V8C4.5 7.72386 4.72386 7.5 5 7.5H6.25ZM4.5 19V13.25H19.5V19C19.5 19.2761 19.2761 19.5 19 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var SpritesheetIcons_Date = (Date_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/DateAdd.mjs
function cov_1w5oadkl5a() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateAdd.tsx";
  var hash = "868e2ee25aea3b5f3648051bad428642627f0827";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateAdd.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "868e2ee25aea3b5f3648051bad428642627f0827"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1w5oadkl5a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1w5oadkl5a();
var DateAdd_Icon = (cov_1w5oadkl5a().s[0]++, {
  name: 'date-add',
  svg: "<path d=\"M12 12.25C12.6904 12.25 13.25 12.8096 13.25 13.5V14H14C14.6904 14 15.25 14.5596 15.25 15.25C15.25 15.9404 14.6904 16.5 14 16.5H13.25V17C13.25 17.6904 12.6904 18.25 12 18.25C11.3096 18.25 10.75 17.6904 10.75 17V16.5H10C9.30964 16.5 8.75 15.9404 8.75 15.25C8.75 14.5596 9.30964 14 10 14H10.75V13.5C10.75 12.8096 11.3096 12.25 12 12.25Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 3C8.25 2.30964 7.69036 1.75 7 1.75C6.30964 1.75 5.75 2.30964 5.75 3V4H5C3.34315 4 2 5.34315 2 7V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V7C22 5.34315 20.6569 4 19 4H18.25V3C18.25 2.30964 17.6904 1.75 17 1.75C16.3096 1.75 15.75 2.30964 15.75 3V4H8.25V3ZM5.75 6.5V7C5.75 7.69036 6.30964 8.25 7 8.25C7.69036 8.25 8.25 7.69036 8.25 7V6.5H15.75V7C15.75 7.69036 16.3096 8.25 17 8.25C17.6904 8.25 18.25 7.69036 18.25 7V6.5H19C19.2761 6.5 19.5 6.72386 19.5 7V8.75H4.5V7C4.5 6.72386 4.72386 6.5 5 6.5H5.75ZM4.5 19V11.25H19.5V19C19.5 19.2761 19.2761 19.5 19 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var DateAdd = (DateAdd_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/DateChecked.mjs
function cov_1hns54ezz0() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateChecked.tsx";
  var hash = "6c407941aea9b6b9b82c171f9abd06a3089dbab4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateChecked.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6c407941aea9b6b9b82c171f9abd06a3089dbab4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hns54ezz0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1hns54ezz0();
var DateChecked_Icon = (cov_1hns54ezz0().s[0]++, {
  name: 'date-checked',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.75 3C8.75 2.30964 8.19036 1.75 7.5 1.75C6.80964 1.75 6.25 2.30964 6.25 3V5H5C3.34315 5 2 6.34315 2 8V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V8C22 6.34315 20.6569 5 19 5H17.75V3C17.75 2.30964 17.1904 1.75 16.5 1.75C15.8096 1.75 15.25 2.30964 15.25 3V5H8.75V3ZM6.25 7.5V7.9C6.25 8.59036 6.80964 9.15 7.5 9.15C8.19036 9.15 8.75 8.59036 8.75 7.9V7.5H15.25V7.9C15.25 8.59036 15.8096 9.15 16.5 9.15C17.1904 9.15 17.75 8.59036 17.75 7.9V7.5H19C19.2761 7.5 19.5 7.72386 19.5 8V19C19.5 19.2761 19.2761 19.5 19 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V8C4.5 7.72386 4.72386 7.5 5 7.5H6.25Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.7678 11.5L10.5 17.7678L7.23223 14.5L9 12.7322L10.5 14.2322L15 9.73223L16.7678 11.5Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var DateChecked = (DateChecked_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Email.mjs
function cov_1c197j2dhs() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Email.tsx";
  var hash = "39f8aa3133314280f61b435e080bba8d4b08a46e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Email.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "39f8aa3133314280f61b435e080bba8d4b08a46e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1c197j2dhs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1c197j2dhs();
var Email_Icon = (cov_1c197j2dhs().s[0]++, {
  name: 'email',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 21V9.52066C22 9.19434 21.8408 8.88855 21.5735 8.70143L12.5735 2.40143C12.2291 2.1604 11.7709 2.1604 11.4265 2.40143L2.42654 8.70143C2.15921 8.88855 2 9.19434 2 9.52066V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21ZM18.3436 9.49214L12 5.05164L5.65643 9.49214L12 13.97L18.3436 9.49214ZM4.5 11.7359V19.5H19.5V11.7359L13.2975 16.1141C12.5196 16.6632 11.4803 16.6632 10.7025 16.1141L4.5 11.7359Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Email = (Email_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Favorite.mjs
function cov_1e8ymkqpaw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Favorite.tsx";
  var hash = "15b3d37b900412fbb9eecff6f75feb230c3d0d1c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Favorite.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "15b3d37b900412fbb9eecff6f75feb230c3d0d1c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1e8ymkqpaw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1e8ymkqpaw();
var Favorite_Icon = (cov_1e8ymkqpaw().s[0]++, {
  name: 'favorite',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M11.9904 21.5596C11.7763 21.5596 11.5612 21.5211 11.3452 21.4442C11.1291 21.3672 10.9391 21.2467 10.775 21.0826L9.33848 19.7769C7.56539 18.1602 5.98238 16.5721 4.58943 15.0125C3.19648 13.4528 2.5 11.782 2.5 9.99998C2.5 8.58076 2.97852 7.39263 3.93558 6.43558C4.89263 5.47853 6.08076 5 7.49998 5C8.30638 5 9.10285 5.1859 9.8894 5.5577C10.6759 5.9295 11.3795 6.53335 12 7.36925C12.6205 6.53335 13.324 5.9295 14.1105 5.5577C14.8971 5.1859 15.6936 5 16.5 5C17.9192 5 19.1073 5.47853 20.0644 6.43558C21.0214 7.39263 21.5 8.58076 21.5 9.99998C21.5 11.8012 20.7916 13.4907 19.375 15.0682C17.9583 16.6458 16.3788 18.2205 14.6365 19.7923L13.2154 21.0826C13.0513 21.2467 12.8596 21.3672 12.6404 21.4442C12.4211 21.5211 12.2045 21.5596 11.9904 21.5596ZM11.2808 8.88845C10.7397 8.06408 10.1702 7.45992 9.5721 7.07595C8.97402 6.69197 8.28331 6.49998 7.49998 6.49998C6.49998 6.49998 5.66664 6.83331 4.99998 7.49998C4.33331 8.16664 3.99998 8.99998 3.99998 9.99998C3.99998 10.8025 4.25863 11.6416 4.77593 12.5173C5.29323 13.3929 5.94257 14.2634 6.72398 15.1288C7.50539 15.9942 8.35187 16.8397 9.2634 17.6653C10.1749 18.491 11.0198 19.2583 11.798 19.9673C11.8557 20.0186 11.923 20.0442 12 20.0442C12.0769 20.0442 12.1442 20.0186 12.2019 19.9673C12.9801 19.2583 13.825 18.491 14.7366 17.6653C15.6481 16.8397 16.4946 15.9942 17.276 15.1288C18.0574 14.2634 18.7067 13.3929 19.224 12.5173C19.7413 11.6416 20 10.8025 20 9.99998C20 8.99998 19.6666 8.16664 19 7.49998C18.3333 6.83331 17.5 6.49998 16.5 6.49998C15.7166 6.49998 15.0259 6.69197 14.4279 7.07595C13.8298 7.45992 13.2602 8.06408 12.7192 8.88845C12.6346 9.01665 12.5282 9.11281 12.4 9.17693C12.2718 9.24103 12.1384 9.27308 12 9.27308C11.8615 9.27308 11.7282 9.24103 11.6 9.17693C11.4718 9.11281 11.3654 9.01665 11.2808 8.88845Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Favorite = (Favorite_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/FavoriteFilled.mjs
function cov_1pa8whsf3a() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/FavoriteFilled.tsx";
  var hash = "f26dbe0089c12788f7eb9ee050e92a3da1745f1a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/FavoriteFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f26dbe0089c12788f7eb9ee050e92a3da1745f1a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1pa8whsf3a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1pa8whsf3a();
var FavoriteFilled_Icon = (cov_1pa8whsf3a().s[0]++, {
  name: 'favorite-filled',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M11.9904 21.5596C11.7763 21.5596 11.5612 21.5211 11.3452 21.4442C11.1291 21.3672 10.9391 21.2467 10.775 21.0826L9.33848 19.7769C7.56539 18.1602 5.98238 16.5721 4.58943 15.0125C3.19648 13.4528 2.5 11.782 2.5 9.99998C2.5 8.58076 2.97852 7.39263 3.93558 6.43558C4.89263 5.47853 6.08076 5 7.49998 5C8.30638 5 9.10285 5.1859 9.8894 5.5577C10.6759 5.9295 11.3795 6.53335 12 7.36925C12.6205 6.53335 13.324 5.9295 14.1105 5.5577C14.8971 5.1859 15.6936 5 16.5 5C17.9192 5 19.1073 5.47853 20.0644 6.43558C21.0214 7.39263 21.5 8.58076 21.5 9.99998C21.5 11.8012 20.7916 13.4907 19.375 15.0682C17.9583 16.6458 16.3788 18.2205 14.6365 19.7923L13.2154 21.0826C13.0513 21.2467 12.8596 21.3672 12.6404 21.4442C12.4211 21.5211 12.2045 21.5596 11.9904 21.5596Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var FavoriteFilled = (FavoriteFilled_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Info.mjs
function cov_2htb0e1c1o() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Info.tsx";
  var hash = "9168628323a5c247529f8878c1c10f4a12d206fb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Info.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9168628323a5c247529f8878c1c10f4a12d206fb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2htb0e1c1o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2htb0e1c1o();
var Info_Icon = (cov_2htb0e1c1o().s[0]++, {
  name: 'info',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z\" fill=\"currentColor\"/>\n  <path d=\"M10.5 11.9004C10.5 11.3481 10.9477 10.9004 11.5 10.9004H12.5C13.0523 10.9004 13.5 11.3481 13.5 11.9004V15.9004C13.5 16.4527 13.0523 16.9004 12.5 16.9004H11.5C10.9477 16.9004 10.5 16.4527 10.5 15.9004V11.9004Z\" fill=\"currentColor\"/>\n  <path d=\"M12 9.90039C11.1716 9.90039 10.5 9.22882 10.5 8.40039C10.5 7.57196 11.1716 6.90039 12 6.90039C12.8284 6.90039 13.5 7.57196 13.5 8.40039C13.5 9.22882 12.8284 9.90039 12 9.90039Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Info = (Info_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/InviteFilled.mjs
function cov_15d0spgams() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/InviteFilled.tsx";
  var hash = "a154589d20ef586597c5a3685c8d873d8a5c4764";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/InviteFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 12,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a154589d20ef586597c5a3685c8d873d8a5c4764"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15d0spgams = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_15d0spgams();
var InviteFilled_Icon = (cov_15d0spgams().s[0]++, {
  name: 'invite-filled',
  svg: "<g clip-path=\"url(#clip0_8546_22696)\">\n  <path d=\"M20 15.75C19.7 15.75 19.45 15.65 19.25 15.45C19.05 15.25 18.95 15 18.95 14.7V12.8H17.05C16.75 12.8 16.5 12.7 16.3 12.5C16.1 12.3 16 12.05 16 11.75C16 11.45 16.1 11.2 16.3 11C16.5 10.8 16.75 10.7 17.05 10.7H18.95V8.8C18.95 8.5 19.05 8.25 19.25 8.05C19.45 7.85 19.7 7.75 20 7.75C20.3 7.75 20.55 7.85 20.75 8.05C20.95 8.25 21.05 8.5 21.05 8.8V10.7H22.95C23.25 10.7 23.5 10.8 23.7 11C23.9 11.2 24 11.45 24 11.75C24 12.05 23.9 12.3 23.7 12.5C23.5 12.7 23.25 12.8 22.95 12.8H21.05V14.7C21.05 15 20.95 15.25 20.75 15.45C20.55 15.65 20.3 15.75 20 15.75ZM10.875 13.9C9.725 13.9 8.73733 13.4873 7.912 12.662C7.08733 11.8373 6.675 10.85 6.675 9.7C6.675 8.53333 7.08733 7.54167 7.912 6.725C8.73733 5.90833 9.725 5.5 10.875 5.5C12.0417 5.5 13.0373 5.90833 13.862 6.725C14.6873 7.54167 15.1 8.53333 15.1 9.7C15.1 10.85 14.6873 11.8373 13.862 12.662C13.0373 13.4873 12.0417 13.9 10.875 13.9Z\" fill=\"currentColor\"/>\n  <path d=\"M3.97961 17.8499C5.07231 16.0785 7.0049 15 9.08614 15H12.7528C14.834 15 16.7666 16.0785 17.8593 17.8499L18.5379 18.95C19.3599 20.2824 18.4014 22 16.8358 22H5.00316C3.43755 22 2.479 20.2824 3.30099 18.95L3.97961 17.8499Z\" fill=\"currentColor\"/>\n  </g>\n  <defs>\n  <clipPath id=\"clip0_8546_22696\">\n  <rect width=\"24\" height=\"24\" fill=\"currentColor\"/>\n  </clipPath>\n  </defs>"
});
/* harmony default export */ var InviteFilled = (InviteFilled_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/LiveHelp.mjs
function cov_1d6aaffyyi() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LiveHelp.tsx";
  var hash = "eab5010c6a98514b552f9e70b62ccde13d45b4b3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LiveHelp.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 49
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "eab5010c6a98514b552f9e70b62ccde13d45b4b3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1d6aaffyyi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1d6aaffyyi();
var LiveHelp_Icon = (cov_1d6aaffyyi().s[0]++, {
  name: 'live-help',
  svg: "<path d=\"M19 1.5H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2Zm0 16h-4.83L12 19.67 9.83 17.5H5v-14h14v14Zm-8-3h2v2h-2v-2Zm1-8c1.1 0 2 .9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4s-4 1.79-4 4h2c0-1.1.9-2 2-2Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var LiveHelp = (LiveHelp_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Money.mjs
function cov_unyg214vc() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Money.tsx";
  var hash = "54a0d18225c930de23f74fab7fd3626da8548293";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Money.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "54a0d18225c930de23f74fab7fd3626da8548293"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_unyg214vc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_unyg214vc();
var Money_Icon = (cov_unyg214vc().s[0]++, {
  name: 'money',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 6.25C10.6236 6.25 9.5305 7.08682 8.83862 8.12464C8.14091 9.1712 7.75 10.545 7.75 12C7.75 13.455 8.14091 14.8288 8.83862 15.8754C9.5305 16.9132 10.6236 17.75 12 17.75C13.3764 17.75 14.4695 16.9132 15.1614 15.8754C15.8591 14.8288 16.25 13.455 16.25 12C16.25 10.545 15.8591 9.1712 15.1614 8.12464C14.4695 7.08682 13.3764 6.25 12 6.25ZM10.25 12C10.25 10.9697 10.5307 10.0935 10.9187 9.51139C11.3126 8.92053 11.7196 8.75 12 8.75C12.2804 8.75 12.6874 8.92053 13.0813 9.51139C13.4693 10.0935 13.75 10.9697 13.75 12C13.75 13.0303 13.4693 13.9065 13.0813 14.4886C12.6874 15.0795 12.2804 15.25 12 15.25C11.7196 15.25 11.3126 15.0795 10.9187 14.4886C10.5307 13.9065 10.25 13.0303 10.25 12Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 19.25C0 20.2165 0.783502 21 1.75 21H22.25C23.2165 21 24 20.2165 24 19.25V4.75C24 3.7835 23.2165 3 22.25 3H1.75C0.783502 3 0 3.7835 0 4.75V19.25ZM5.95852 5.5C5.9858 5.6626 6 5.82964 6 6C6 7.65685 4.65685 9 3 9C2.82964 9 2.6626 8.9858 2.5 8.95852V15.0415C2.6626 15.0142 2.82964 15 3 15C4.65685 15 6 16.3431 6 18C6 18.1704 5.9858 18.3374 5.95852 18.5H18.0415C18.0142 18.3374 18 18.1704 18 18C18 16.3431 19.3431 15 21 15C21.1704 15 21.3374 15.0142 21.5 15.0415V8.95852C21.3374 8.9858 21.1704 9 21 9C19.3431 9 18 7.65685 18 6C18 5.82964 18.0142 5.6626 18.0415 5.5H5.95852Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Money = (Money_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/NewTab.mjs
function cov_2aeau7yxor() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewTab.tsx";
  var hash = "fd7172e4b020de994de21291bf9b33d5c136fd04";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewTab.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fd7172e4b020de994de21291bf9b33d5c136fd04"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2aeau7yxor = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2aeau7yxor();
var NewTab_Icon = (cov_2aeau7yxor().s[0]++, {
  name: 'new-tab',
  svg: "<path d=\"M21.9498 10.0267L22.0065 1.98876L13.1912 2.05015C12.5008 2.05496 11.9451 2.61849 11.9499 3.30882C11.9547 3.99916 12.5182 4.5549 13.2086 4.55009L17.4399 4.52062L10.1161 11.8444C9.6279 12.3326 9.6279 13.1241 10.1161 13.6122C10.6042 14.1004 11.3957 14.1004 11.8838 13.6122L19.478 6.01801L19.4499 10.0091C19.445 10.6994 20.0007 11.263 20.6911 11.2678C21.3814 11.2727 21.945 10.717 21.9498 10.0267Z\" fill=\"currentColor\"/>\n  <path d=\"M4.44995 7.25H9.19995C9.89031 7.25 10.45 6.69035 10.45 6C10.45 5.30964 9.89031 4.75 9.19995 4.75H4.19995C2.95731 4.75 1.94995 5.75736 1.94995 7V20C1.94995 21.2426 2.95731 22.25 4.19995 22.25H17.2C18.4426 22.25 19.45 21.2426 19.45 20V14C19.45 13.3096 18.8903 12.75 18.2 12.75C17.5096 12.75 16.95 13.3096 16.95 14V19.75H4.44995V7.25Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var NewTab = (NewTab_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Pdf.mjs
function cov_2miija2ty0() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Pdf.tsx";
  var hash = "d1eebc7c8ef1565cfd4d96a03fc7330e98728038";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Pdf.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 43
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d1eebc7c8ef1565cfd4d96a03fc7330e98728038"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2miija2ty0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2miija2ty0();
var Pdf_Icon = (cov_2miija2ty0().s[0]++, {
  name: 'pdf',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 9.5C11.5 10.33 10.83 11 10 11H9V12.25C9 12.66 8.66 13 8.25 13C7.84 13 7.5 12.66 7.5 12.25V8C7.5 7.45 7.95 7 8.5 7H10C10.83 7 11.5 7.67 11.5 8.5V9.5ZM15 13C15.83 13 16.5 12.33 16.5 11.5V8.5C16.5 7.67 15.83 7 15 7H13C12.72 7 12.5 7.22 12.5 7.5V12.5C12.5 12.78 12.72 13 13 13H15ZM20.5 7.75C20.5 8.16 20.16 8.5 19.75 8.5H19V9.5H19.75C20.16 9.5 20.5 9.84 20.5 10.25C20.5 10.66 20.16 11 19.75 11H19V12.25C19 12.66 18.66 13 18.25 13C17.84 13 17.5 12.66 17.5 12.25V8C17.5 7.45 17.95 7 18.5 7H19.75C20.16 7 20.5 7.34 20.5 7.75ZM10 9.5H9V8.5H10V9.5ZM3 6C2.45 6 2 6.45 2 7V20C2 21.1 2.9 22 4 22H17C17.55 22 18 21.55 18 21C18 20.45 17.55 20 17 20H5C4.45 20 4 19.55 4 19V7C4 6.45 3.55 6 3 6ZM15 11.5H14V8.5H15V11.5Z\" fill=\"#222222\"/>"
});
/* harmony default export */ var Pdf = (Pdf_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Phone.mjs
function cov_1wvp0bza2u() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Phone.tsx";
  var hash = "7f6489952f947bf6b9ad35a00cfe55a9617156c8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Phone.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7f6489952f947bf6b9ad35a00cfe55a9617156c8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1wvp0bza2u = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1wvp0bza2u();
var Phone_Icon = (cov_1wvp0bza2u().s[0]++, {
  name: 'phone',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.73635 4.7732C5.02641 4.65281 5.33739 4.59082 5.65148 4.59082C5.96557 4.59082 6.27655 4.65281 6.56661 4.7732C6.85621 4.89341 7.11929 5.06949 7.34082 5.29139L7.34191 5.29248L9.16112 7.10911C9.52237 7.47379 9.757 7.94481 9.83054 8.45282C9.90321 8.9548 9.81479 9.46676 9.5782 9.91511L9.00884 11.0403C9.01143 11.0562 9.01397 11.0713 9.01692 11.0888C9.01861 11.0989 9.02043 11.1097 9.02247 11.1219C9.02815 11.1559 9.03511 11.1982 9.04153 11.2425C9.04335 11.255 9.04506 11.2672 9.04665 11.279L12.6275 14.8623C12.6497 14.8518 12.6722 14.842 12.6949 14.8329L14.05 14.2886C14.4847 14.0721 14.9759 13.9928 15.4579 14.0626C15.9683 14.1365 16.4412 14.3735 16.8058 14.7383L16.8068 14.7393L18.6205 16.5582L18.622 16.5597C18.8437 16.7812 19.0197 17.0441 19.1398 17.3335C19.2602 17.6236 19.3222 17.9346 19.3222 18.2487C19.3222 18.5627 19.2602 18.8737 19.1398 19.1638C19.0195 19.4535 18.8433 19.7167 18.6213 19.9383L18.6205 19.9391L17.4696 21.09C16.9641 21.6015 16.317 21.9499 15.6116 22.0901C14.905 22.2306 14.1725 22.1558 13.509 21.8754C8.33303 19.6989 4.21548 15.5817 2.03851 10.4061C1.75661 9.74512 1.67901 9.01487 1.81576 8.30937C1.95271 7.60287 2.29832 6.95365 2.80796 6.44556L3.96184 5.29168C4.18344 5.06964 4.44662 4.89346 4.73635 4.7732ZM8.99362 10.9283L8.99371 10.9302L8.99362 10.9283ZM5.65154 7.13752L4.57331 8.21574C4.41756 8.37091 4.31192 8.56925 4.27008 8.78511C4.22824 9.00097 4.25212 9.2244 4.33861 9.42653L4.34175 9.43385C6.2651 14.0087 9.90429 17.6479 14.4791 19.5713L14.4817 19.5724C14.6844 19.6581 14.9082 19.681 15.1241 19.6381C15.34 19.5952 15.538 19.4884 15.6925 19.3316L15.6989 19.3251L16.7755 18.2486L15.0937 16.5619C15.0749 16.5705 15.056 16.5787 15.0368 16.5864L13.6842 17.1296C13.2544 17.3457 12.7688 17.4278 12.2906 17.364C11.7828 17.2963 11.31 17.0676 10.9415 16.7116L10.926 16.6963L7.11582 12.8836C6.85296 12.6203 6.70861 12.3274 6.63679 12.0362C6.60694 11.9152 6.59274 11.8066 6.58496 11.7437C6.58067 11.7091 6.57804 11.6863 6.57596 11.6684C6.57303 11.6431 6.57121 11.6275 6.56742 11.6013C6.56742 11.6013 6.56698 11.5987 6.56631 11.5949C6.55868 11.5507 6.51389 11.2918 6.50097 11.1209C6.48504 10.91 6.4751 10.4959 6.6944 10.0771L7.33248 8.81609L5.65154 7.13752Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.2992 2.19698C11.7039 1.74307 13.1969 1.63284 14.653 1.87558C16.0143 2.10038 17.3051 2.63687 18.4248 3.44311C19.9907 4.55929 21.1647 6.14092 21.7797 7.96296C22.3951 9.78612 22.4194 11.757 21.8492 13.5948C21.6446 14.2541 20.9443 14.6228 20.2849 14.4182C19.6256 14.2136 19.2569 13.5133 19.4615 12.8539C19.8757 11.5188 19.858 10.087 19.411 8.76249C18.9639 7.43799 18.1102 6.28835 16.9716 5.47738L16.9659 5.47332C16.1581 4.89116 15.2265 4.5039 14.2441 4.34191L14.2419 4.34155C13.1804 4.16459 12.092 4.24495 11.068 4.57585C10.4111 4.78814 9.70644 4.4277 9.49416 3.77079C9.28188 3.11388 9.64231 2.40927 10.2992 2.19698Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.4222 6.36638C13.3336 6.22556 14.2663 6.36228 15.0989 6.75875C15.9307 7.15478 16.6241 7.79166 17.0893 8.58671C17.3015 8.94648 17.4611 9.33481 17.5631 9.73984C17.684 10.2187 17.7279 10.7137 17.6933 11.2063C17.6448 11.895 17.0472 12.414 16.3586 12.3655C15.6699 12.317 15.151 11.7195 15.1994 11.0308C15.2155 10.8027 15.1951 10.5735 15.1392 10.3517C15.0953 10.1777 15.0266 10.0102 14.9353 9.85571L14.9322 9.85048C14.7202 9.48747 14.4038 9.19668 14.0242 9.01593C13.6446 8.83519 13.2194 8.77287 12.8039 8.83706C12.1217 8.94248 11.4831 8.47486 11.3777 7.7926C11.2723 7.11034 11.7399 6.4718 12.4222 6.36638Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Phone = (Phone_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Plus.mjs
function cov_1als1qnknh() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Plus.tsx";
  var hash = "8fefe3f3cf4f104090272268fd3a6b4f6d70fc7e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Plus.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8fefe3f3cf4f104090272268fd3a6b4f6d70fc7e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1als1qnknh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1als1qnknh();
var Plus_Icon = (cov_1als1qnknh().s[0]++, {
  name: 'plus',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M11.25 12.75H6.25C6.0375 12.75 5.85938 12.6781 5.71563 12.5343C5.57188 12.3904 5.5 12.2122 5.5 11.9997C5.5 11.7871 5.57188 11.609 5.71563 11.4654C5.85938 11.3218 6.0375 11.25 6.25 11.25H11.25V6.25C11.25 6.0375 11.3219 5.85938 11.4657 5.71563C11.6095 5.57188 11.7877 5.5 12.0003 5.5C12.2129 5.5 12.391 5.57188 12.5346 5.71563C12.6782 5.85938 12.7499 6.0375 12.7499 6.25V11.25H17.75C17.9625 11.25 18.1406 11.3219 18.2843 11.4657C18.4281 11.6095 18.5 11.7877 18.5 12.0003C18.5 12.2129 18.4281 12.391 18.2843 12.5346C18.1406 12.6782 17.9625 12.75 17.75 12.75H12.7499V17.75C12.7499 17.9625 12.678 18.1406 12.5342 18.2843C12.3904 18.4281 12.2122 18.5 11.9997 18.5C11.7871 18.5 11.609 18.4281 11.4654 18.2843C11.3218 18.1406 11.25 17.9625 11.25 17.75V12.75Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Plus = (Plus_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Refresh.mjs
function cov_zjteypsrj() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Refresh.tsx";
  var hash = "5fa1ed5e0fe75a8d687f6915507f2a5db6379690";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Refresh.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5fa1ed5e0fe75a8d687f6915507f2a5db6379690"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_zjteypsrj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_zjteypsrj();
var Refresh_Icon = (cov_zjteypsrj().s[0]++, {
  name: 'refresh',
  svg: "<path d=\"M11.109 6.41925L10.6116 6.83381C10.0812 7.27576 10.0096 8.06397 10.4515 8.59432C10.8935 9.12466 11.6817 9.19632 12.212 8.75436L15.2046 6.26056C15.9 5.68106 15.9 4.61301 15.2046 4.03351L12.212 1.53969C11.6817 1.09774 10.8935 1.16939 10.4515 1.69974C10.0096 2.23008 10.0812 3.01829 10.6116 3.46025L11.142 3.90228C6.44006 4.30727 2.75 8.2523 2.75 13.0592C2.75 18.1353 6.86503 22.2504 11.9412 22.2504C17.0173 22.2504 21.1324 18.1353 21.1324 13.0592C21.1324 12.3688 20.5727 11.8092 19.8824 11.8092C19.192 11.8092 18.6324 12.3688 18.6324 13.0592C18.6324 16.7546 15.6366 19.7504 11.9412 19.7504C8.24574 19.7504 5.25 16.7546 5.25 13.0592C5.25 9.64554 7.80629 6.82895 11.109 6.41925Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Refresh = (Refresh_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Search.mjs
function cov_24gw0wugli() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Search.tsx";
  var hash = "f04cf378461ed0a24ded6ccb5069433e7dfe4d08";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Search.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f04cf378461ed0a24ded6ccb5069433e7dfe4d08"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24gw0wugli = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24gw0wugli();
var Search_Icon = (cov_24gw0wugli().s[0]++, {
  name: 'search',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5682 16.5683C13.273 17.4708 11.6983 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8177 17.3938 13.4937 16.3726 14.8371L21.7678 20.2323C22.2559 20.7205 22.2559 21.5119 21.7678 22.0001C21.2796 22.4883 20.4882 22.4883 20 22.0001L14.5682 16.5683ZM15.5 10C15.5 13.0376 13.0376 15.5 10 15.5C6.96243 15.5 4.5 13.0376 4.5 10C4.5 6.96243 6.96243 4.5 10 4.5C13.0376 4.5 15.5 6.96243 15.5 10Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Search = (Search_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Sign.mjs
function cov_22gaw4obv3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Sign.tsx";
  var hash = "0115ae27a59e117d380559b53ca8497b536bd860";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Sign.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0115ae27a59e117d380559b53ca8497b536bd860"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22gaw4obv3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_22gaw4obv3();
var Sign_Icon = (cov_22gaw4obv3().s[0]++, {
  name: 'sign',
  svg: "<path d=\"M5.25 3C5.25 2.30964 4.69036 1.75 4 1.75C3.30964 1.75 2.75 2.30964 2.75 3V3.75H2C1.30964 3.75 0.75 4.30964 0.75 5C0.75 5.69036 1.30964 6.25 2 6.25H2.75L2.75 22.05H5.25L5.25 6.25H21C21.6904 6.25 22.25 5.69036 22.25 5C22.25 4.30964 21.6904 3.75 21 3.75H5.25V3Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 10.5H10C9.72386 10.5 9.5 10.7239 9.5 11V17C9.5 17.2761 9.72386 17.5 10 17.5H19C19.2761 17.5 19.5 17.2761 19.5 17V11C19.5 10.7239 19.2761 10.5 19 10.5ZM10 8C8.34315 8 7 9.34315 7 11V17C7 18.6569 8.34315 20 10 20H19C20.6569 20 22 18.6569 22 17V11C22 9.34315 20.6569 8 19 8H10Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Sign = (Sign_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/SignFilled.mjs
function cov_1dmvb5101b() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SignFilled.tsx";
  var hash = "1fa8fa53f7608455f569b3f016af186dfae25e39";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SignFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1fa8fa53f7608455f569b3f016af186dfae25e39"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1dmvb5101b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1dmvb5101b();
var SignFilled_Icon = (cov_1dmvb5101b().s[0]++, {
  name: 'sign-filled',
  svg: "<path d=\"M5.25 3C5.25 2.30964 4.69036 1.75 4 1.75C3.30964 1.75 2.75 2.30964 2.75 3V3.75H2C1.30964 3.75 0.75 4.30964 0.75 5C0.75 5.69036 1.30964 6.25 2 6.25H2.75L2.75 22.05H5.25L5.25 6.25H21C21.6904 6.25 22.25 5.69036 22.25 5C22.25 4.30964 21.6904 3.75 21 3.75H5.25V3Z\" fill=\"currentColor\"/>\n  <path d=\"M7 11C7 9.34315 8.34315 8 10 8H19C20.6569 8 22 9.34315 22 11V17C22 18.6569 20.6569 20 19 20H10C8.34315 20 7 18.6569 7 17V11Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var SignFilled = (SignFilled_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/UnlockLeft.mjs
function cov_v9hvqvka7() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockLeft.tsx";
  var hash = "f3193bc7a30facdf6d5d15a9882adf8849418d3d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockLeft.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f3193bc7a30facdf6d5d15a9882adf8849418d3d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_v9hvqvka7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_v9hvqvka7();
var UnlockLeft_Icon = (cov_v9hvqvka7().s[0]++, {
  name: 'unlock-left',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.5 12.5V19.5H18.5V12.5H5.5ZM5 10C3.89543 10 3 10.8954 3 12V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V12C21 10.8954 20.1046 10 19 10H5Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 7C6.75 4.10051 9.1005 1.75 12 1.75C14.8995 1.75 17.25 4.10051 17.25 7V12H14.75V7C14.75 5.48122 13.5188 4.25 12 4.25C10.4812 4.25 9.25 5.48122 9.25 7V7.5H6.75V7Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var UnlockLeft = (UnlockLeft_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/UnlockRight.mjs
function cov_dx6z4mk26() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockRight.tsx";
  var hash = "0a71eae2e0885829486bfa2cdf9f730b1daa6f4c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockRight.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0a71eae2e0885829486bfa2cdf9f730b1daa6f4c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dx6z4mk26 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_dx6z4mk26();
var UnlockRight_Icon = (cov_dx6z4mk26().s[0]++, {
  name: 'unlock-right',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.5 12.5V19.5H18.5V12.5H5.5ZM5 10C3.89543 10 3 10.8954 3 12V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V12C21 10.8954 20.1046 10 19 10H5Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.25 7C17.25 4.10051 14.8995 1.75 12 1.75C9.10051 1.75 6.75 4.10051 6.75 7V12H9.25V7C9.25 5.48122 10.4812 4.25 12 4.25C13.5188 4.25 14.75 5.48122 14.75 7V7.5H17.25V7Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var UnlockRight = (UnlockRight_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Video.mjs
function cov_27ficyzang() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Video.tsx";
  var hash = "d6c436fb7e34b520759c853296bce8b2908beca5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Video.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d6c436fb7e34b520759c853296bce8b2908beca5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_27ficyzang = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_27ficyzang();
var Video_Icon = (cov_27ficyzang().s[0]++, {
  name: 'video',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.1126 13.6338L20.5 16.0558V8.58415L14.1126 11.0062V6.5H3.5V17.5H14.1126V13.6338ZM20.1198 6.05462C20.14 6.04799 20.1601 6.04133 20.1803 6.03467C21.5435 5.5851 23 5.10473 23 7.67391V16.9661C23 18.9333 22.5 19.4667 20.1198 18.5854L16.6126 17.2555V18.08C16.6126 18.7198 16.3073 19.2865 15.8378 19.6354C15.5291 19.8648 15.1495 20 14.7391 20H2.87351C1.8388 20 1 19.1404 1 18.08V5.92C1 4.85961 1.8388 4 2.87351 4H14.7391C15.3809 4 15.9474 4.33076 16.285 4.83503C16.4917 5.1437 16.6126 5.51737 16.6126 5.92V7.3845L20.1198 6.05462ZM20.472 7.28017L20.4716 7.27848L20.472 7.28017Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Video = (Video_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Warning.mjs
function cov_tepf5j48j() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Warning.tsx";
  var hash = "0c170c9f52eb929ba3d0332c74b4e6d7e855ae3e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Warning.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0c170c9f52eb929ba3d0332c74b4e6d7e855ae3e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_tepf5j48j = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_tepf5j48j();
var Warning_Icon = (cov_tepf5j48j().s[0]++, {
  name: 'warning',
  svg: "<path d=\"M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z\" fill=\"currentColor\"/>\n  <path d=\"M10.875 16.125C10.875 16.4234 10.9935 16.7095 11.2045 16.9205C11.4155 17.1315 11.7016 17.25 12 17.25C12.2984 17.25 12.5845 17.1315 12.7955 16.9205C13.0065 16.7095 13.125 16.4234 13.125 16.125C13.125 15.8266 13.0065 15.5405 12.7955 15.3295C12.5845 15.1185 12.2984 15 12 15C11.7016 15 11.4155 15.1185 11.2045 15.3295C10.9935 15.5405 10.875 15.8266 10.875 16.125ZM11.4375 13.5H12.5625C12.6656 13.5 12.75 13.4156 12.75 13.3125V6.9375C12.75 6.83437 12.6656 6.75 12.5625 6.75H11.4375C11.3344 6.75 11.25 6.83437 11.25 6.9375V13.3125C11.25 13.4156 11.3344 13.5 11.4375 13.5Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ var Warning = (Warning_Icon);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Spritesheet.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _ref;
function cov_1q9eio50nx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/Spritesheet.tsx";
  var hash = "582b76167dbe0647348fd4ad90df1f3fe9dfa1ec";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/Spritesheet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 46,
          column: 70
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "1": {
        start: {
          line: 86,
          column: 86
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "2": {
        start: {
          line: 113,
          column: 2
        },
        end: {
          line: 128,
          column: 4
        }
      },
      "3": {
        start: {
          line: 117,
          column: 10
        },
        end: {
          line: 117,
          column: 92
        }
      },
      "4": {
        start: {
          line: 120,
          column: 10
        },
        end: {
          line: 124,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "Spritesheet",
        decl: {
          start: {
            line: 112,
            column: 24
          },
          end: {
            line: 112,
            column: 35
          }
        },
        loc: {
          start: {
            line: 112,
            column: 38
          },
          end: {
            line: 129,
            column: 1
          }
        },
        line: 112
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 116,
            column: 44
          },
          end: {
            line: 116,
            column: 45
          }
        },
        loc: {
          start: {
            line: 117,
            column: 10
          },
          end: {
            line: 117,
            column: 92
          }
        },
        line: 117
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 119,
            column: 58
          },
          end: {
            line: 119,
            column: 59
          }
        },
        loc: {
          start: {
            line: 120,
            column: 10
          },
          end: {
            line: 124,
            column: 12
          }
        },
        line: 120
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "582b76167dbe0647348fd4ad90df1f3fe9dfa1ec"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1q9eio50nx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1q9eio50nx();
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






















































// DO NOT EXPORT: If you need all the names of the icons, use the
// SPRITESHEET_ICONS_MANIFEST
var SPRITESHEET_ICONS = (cov_1q9eio50nx().s[0]++, (_ref = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, ArrowLeft.name, ArrowLeft.svg), ArrowRight.name, ArrowRight.svg), Avatar.name, Avatar.svg), CenterFocusStrong.name, CenterFocusStrong.svg), ChatInactive.name, ChatInactive.svg), Checkmark/* default.name */.Z.name, Checkmark/* default.svg */.Z.svg), Close.name, Close.svg), Close16.name, Close16.svg), ChevronDown.name, ChevronDown.svg), ChevronDown16.name, ChevronDown16.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, ChevronLeft.name, ChevronLeft.svg), ChevronRight.name, ChevronRight.svg), ChevronUp.name, ChevronUp.svg), ContactPhone.name, ContactPhone.svg), SpritesheetIcons_Date.name, SpritesheetIcons_Date.svg), DateAdd.name, DateAdd.svg), DateChecked.name, DateChecked.svg), Email.name, Email.svg), Favorite.name, Favorite.svg), FavoriteFilled.name, FavoriteFilled.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Info.name, Info.svg), InviteFilled.name, InviteFilled.svg), LiveHelp.name, LiveHelp.svg), Money.name, Money.svg), NewTab.name, NewTab.svg), Pdf.name, Pdf.svg), Phone.name, Phone.svg), Plus.name, Plus.svg), Refresh.name, Refresh.svg), Search.name, Search.svg), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, Sign.name, Sign.svg), SignFilled.name, SignFilled.svg), UnlockLeft.name, UnlockLeft.svg), UnlockRight.name, UnlockRight.svg), Video.name, Video.svg), Warning.name, Warning.svg)));

// SIZE_SPECIFIC_ICONS_MANIFEST
var SIZE_SPECIFIC_SPRITESHEET_ICONS = (cov_1q9eio50nx().s[1]++, _defineProperty(_defineProperty({}, ChevronLeft12.name, ChevronLeft12.svg), ChevronRight12.name, ChevronRight12.svg));

/**
 * The spritesheet component contains all of the EERO icons. It is injected once
 * per page. Individual icons are then made using the Icon component.
 * Icon takes `name` as a prop which refers to the keys in the
 * `SPRITESHEET_ICONS` object. To add an icon to the spritesheet:
 * 1. Add a new "name" to the SPRITESHEET_ICONS_MANIFEST object in ./SpritesheetManifest.tsx
 * 2. Add a new file to './SpritesheetIcons/YourNewIcon.tsx' and export
 *    the `name` and `svg` object.
 * 3. Add to the SPRITESHEET_ICONS object, by importing and adding
 *    import YourNewIcon from './SpritesheetIcons/YourNewIcon'
 *    ...
 *    [YourNewIcon.name]: YourNewIcon.svg
 * a key and the raw SVG code as value to the `SPRITESHEET_ICONS` object.
 *
 * When adding an icon to the spritesheet for which the color is meant to be
 * dynamic set each fill and stroke that is meant to be a dynamic color to
 * `currentColor`. For icons with static colors leave the strokes and fills as
 * is.
 *
 * [One-pager](https://docs.google.com/document/d/16wEXOzW3fPz3WafU6wJ8gtYAJl70_CE8TJUP8_-rgYs/edit?usp=sharing)
 */
function Spritesheet() {
  cov_1q9eio50nx().f[0]++;
  cov_1q9eio50nx().s[2]++;
  return /*#__PURE__*/react.createElement(bricks_types/* bricks.svg */.G.svg, {
    opacity: 0,
    width: 0,
    height: 0,
    display: "block",
    "aria-hidden": "true"
  }, /*#__PURE__*/react.createElement("defs", null, Object.keys(SPRITESHEET_ICONS).map(function (id) {
    cov_1q9eio50nx().f[1]++;
    cov_1q9eio50nx().s[3]++;
    return /*#__PURE__*/react.createElement("g", {
      key: id,
      id: id,
      dangerouslySetInnerHTML: {
        __html: SPRITESHEET_ICONS[id]
      }
    });
  }), Object.keys(SIZE_SPECIFIC_SPRITESHEET_ICONS).map(function (id) {
    cov_1q9eio50nx().f[2]++;
    cov_1q9eio50nx().s[4]++;
    return /*#__PURE__*/react.createElement("g", {
      key: id,
      id: id,
      dangerouslySetInnerHTML: {
        __html: SIZE_SPECIFIC_SPRITESHEET_ICONS[id]
      }
    });
  })));
}
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/styles/FontFace.mjs
function cov_28e88htlke() {
  var path = "/__w/code/code/js/packages/bricks/src/styles/FontFace.tsx";
  var hash = "39acc2af239b40568310f2c203694ecb7cea6bc4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/styles/FontFace.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 34
        },
        end: {
          line: 100,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 99,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 34
          },
          end: {
            line: 10,
            column: 35
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 99,
            column: 4
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "39acc2af239b40568310f2c203694ecb7cea6bc4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28e88htlke = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28e88htlke();



/**
 * Globally defined font definitions for the theme.
 * Currently font are also defined in packages/primer/stylesheets/market/variables.less -
 * this will ultimately replace the less file.
 */
cov_28e88htlke().s[0]++;
var FontFace = function FontFace() {
  cov_28e88htlke().f[0]++;
  cov_28e88htlke().s[1]++;
  return /*#__PURE__*/react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles: "\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Graphik-Regular'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 500;\n        src: local('Graphik-Medium'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Graphik-Semibold'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Semibold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 800;\n        src: local('Graphik-Bold'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Bold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Noto-Mono';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Noto-Mono-Regular'), local('Noto-Mono'),\n          url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Publico-Regular'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-weight: 500;\n        src: local('Publico-Medium'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Publico-Bold'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Publico-Regular'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-weight: 500;\n        src: local('Publico-Medium'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Publico-Bold'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2');\n      }\n\n      body,\n      input,\n      select {\n        text-rendering: optimizeLegibility;\n\n        // Base font size for all breakpoints\n        font: 400 16px / 1.7 'Graphik', sans-serif;\n        color: var(--colors-neutrals100);\n      }\n    "
  });
};
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/styles/Reset.mjs
var Reset = __webpack_require__(75590);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/index.mjs + 2 modules
var es_theme = __webpack_require__(91567);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ThemeOverrideExpiredBanner.mjs + 4 modules
var ThemeOverrideExpiredBanner = __webpack_require__(58605);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/ODTheme.mjs






var _excluded = ["children"];
function cov_2ijo9jc43y() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/ODTheme.tsx";
  var hash = "706ff77feed03f8de73212117c1fb36840db55a4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/ODTheme.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 45
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "1": {
        start: {
          line: 18,
          column: 24
        },
        end: {
          line: 18,
          column: 76
        }
      },
      "2": {
        start: {
          line: 19,
          column: 14
        },
        end: {
          line: 19,
          column: 48
        }
      },
      "3": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 29
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 38
        }
      },
      "6": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 41,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 45
          },
          end: {
            line: 16,
            column: 46
          }
        },
        loc: {
          start: {
            line: 16,
            column: 73
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 18,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 47
          },
          end: {
            line: 18,
            column: 62
          }
        }, {
          start: {
            line: 18,
            column: 65
          },
          end: {
            line: 18,
            column: 76
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 37
          }
        }, {
          start: {
            line: 19,
            column: 41
          },
          end: {
            line: 19,
            column: 47
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 22
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "706ff77feed03f8de73212117c1fb36840db55a4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ijo9jc43y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ijo9jc43y();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








// This uses an SVG spritesheet which must be injected once per page.
// The approach is detailed [here](https://css-tricks.com/svg-sprites-use-better-icon-fonts/)
// Some of the pros and cons of this approach are detailed [here](https://opendoor.slack.com/archives/C023V2C14BX/p1628281932070100)
cov_2ijo9jc43y().s[0]++;
var Themed = function Themed(_ref) {
  var _ref2;
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_2ijo9jc43y().f[0]++;
  // Determines the base theme to apply to the component library
  var baseThemeName = (cov_2ijo9jc43y().s[1]++, 'baseTheme' in props ? (cov_2ijo9jc43y().b[0][0]++, props.baseTheme) : (cov_2ijo9jc43y().b[0][1]++, props.theme));
  var theme = (cov_2ijo9jc43y().s[2]++, es_theme/* THEME_MAP */.v[(_ref2 = (cov_2ijo9jc43y().b[1][0]++, baseThemeName)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2ijo9jc43y().b[1][1]++, 'eero')]);

  // Applies any theme overrides to the base theme
  cov_2ijo9jc43y().s[3]++;
  if ('baseTheme' in props) {
    cov_2ijo9jc43y().b[2][0]++;
    cov_2ijo9jc43y().s[4]++;
    theme = cloneDeep(theme);
    cov_2ijo9jc43y().s[5]++;
    mergeWith(theme, props.overrides);
  } else {
    cov_2ijo9jc43y().b[2][1]++;
  }
  cov_2ijo9jc43y().s[6]++;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Spritesheet, null), /*#__PURE__*/react.createElement(chakra_ui_system_esm/* ThemeProvider */.f6, _extends({}, props, {
    theme: theme
  }), /*#__PURE__*/react.createElement(FontFace, null), /*#__PURE__*/react.createElement(Reset/* Reset */.A, null), /*#__PURE__*/react.createElement(ReactDatesStyles/* ReactDatesStyles */.i, null), children, /*#__PURE__*/react.createElement(ThemeOverrideExpiredBanner/* ThemeOverrideExpiredBanner */.C, {
    baseTheme: baseThemeName,
    launchDateString: props['launchDateString']
  })));
};

/***/ }),

/***/ 64260:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XH": function() { return /* binding */ abbreviationToStateString; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* unused harmony exports centsToCurrencyString, centsToPrettyCurrencyString, fractionToPercentString */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56977);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_parse_float_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54678);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15306);








var formatCurrency = function formatCurrency(centsValue) {
  var roundToCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var decimalPlaces = roundToCents ? 2 : 0;
  var parsedNum = centsValue.toString().replace(/\$|,/g, '');
  var rounded = parseFloat(parsedNum).toFixed(decimalPlaces);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(Number(rounded)) ? 0 : Number(rounded));
};
var centsToCurrencyString = function centsToCurrencyString(valueCents) {
  var roundToCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return formatCurrency(valueCents / 100, roundToCents);
};
var addSuffix = function addSuffix(dollars, suffix) {
  return "".concat(dollars.toLocaleString('en-US', {
    maximumFractionDigits: suffix === 'k' ? 0 : 1
  })).concat(suffix);
};

// converts currency cents from 24000000 to 240K, 240000000 to 2.4M and
// aspirationally will also handle billions correctly
function centsToPrettyCurrencyString(valueCents) {
  var showDollarSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var valueInDollars = Math.round(valueCents / 100);
  var absoluteValue = Math.abs(valueInDollars);
  var showNegative = valueCents < 0 ? '-' : '';
  var isBillions = absoluteValue >= 1000000000;
  var isMillions = absoluteValue >= 1000000;
  var isThousands = absoluteValue >= 1000;
  var suffix = isBillions ? 'B' : isMillions ? 'M' : isThousands ? 'K' : '';
  var formattedString = "".concat(absoluteValue);
  if (isBillions) {
    formattedString = addSuffix(absoluteValue / 1000000000, suffix);
  } else if (isMillions) {
    formattedString = addSuffix(absoluteValue / 1000000, suffix);
  } else if (isThousands) {
    formattedString = addSuffix(Math.round(absoluteValue / 1000), suffix);
  }
  return "".concat(showNegative).concat(showDollarSign ? '$' : '').concat(formattedString);
}

/*
TODO: Migrate to use Intl.NumberFormat once typescript is updated
https://v8.dev/features/intl-numberformat#sign
*/
var fractionToPercentString = function fractionToPercentString(valueFraction) {
  var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits,
    style: 'percent'
  }).format(valueFraction);
};

// converts state abbreviation to their full name
var abbreviationToStateString = {
  AL: 'alabama',
  AK: 'alaska',
  AZ: 'arizona',
  AR: 'arkansas',
  CA: 'california',
  CO: 'colorado',
  CT: 'connecticut',
  DE: 'delaware',
  FL: 'florida',
  GA: 'georgia',
  HI: 'hawaii',
  ID: 'idaho',
  IL: 'illinois',
  IN: 'indiana',
  IA: 'iowa',
  KS: 'kansas',
  KY: 'kentucky',
  LA: 'louisiana',
  ME: 'maine',
  MD: 'maryland',
  MA: 'massachusetts',
  MI: 'michigan',
  MN: 'minnesota',
  MS: 'mississippi',
  MO: 'missouri',
  MT: 'montana',
  NE: 'nebraska',
  NV: 'nevada',
  NH: 'new_hampshire',
  NJ: 'new_jersey',
  NM: 'new_mexico',
  NY: 'new_york',
  NC: 'north_carolina',
  ND: 'north_dakota',
  OH: 'ohio',
  OK: 'oklahoma',
  OR: 'oregon',
  PA: 'pennsylvania',
  RI: 'rhode_island',
  SC: 'south_carolina',
  SD: 'south_dakota',
  TN: 'tennessee',
  TX: 'texas',
  UT: 'utah',
  VT: 'vermont',
  VA: 'virginia',
  WA: 'washington',
  WV: 'west_virginia',
  WI: 'wisconsin',
  WY: 'wyoming'
};

/***/ }),

/***/ 79879:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconExclamationCircle; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 9v4", "key": "svg-1" }], ["path", { "d": "M12 16v.01", "key": "svg-2" }]];
const IconExclamationCircle = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "exclamation-circle", "ExclamationCircle", __iconNode);


//# sourceMappingURL=IconExclamationCircle.mjs.map


/***/ }),

/***/ 79384:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconMail; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }]];
const IconMail = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "mail", "Mail", __iconNode);


//# sourceMappingURL=IconMail.mjs.map


/***/ }),

/***/ 54666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconMessage; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z", "key": "svg-2" }]];
const IconMessage = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "message", "Message", __iconNode);


//# sourceMappingURL=IconMessage.mjs.map


/***/ }),

/***/ 29513:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconShieldLockFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm.002 7a2 2 0 0 0 -1.995 1.85l-.005 .15l.005 .15a2 2 0 0 0 .995 1.581v1.769l.007 .117a1 1 0 0 0 1.993 -.117l.001 -1.768a2 2 0 0 0 -1.001 -3.732z", "key": "svg-0" }]];
const IconShieldLockFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "shield-lock-filled", "ShieldLockFilled", __iconNode);


//# sourceMappingURL=IconShieldLockFilled.mjs.map


/***/ }),

/***/ 77178:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconTruckFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M13 4a1 1 0 0 1 1 1h4a1 1 0 0 1 .783 .378l.074 .108l3 5l.055 .103l.04 .107l.029 .109l.016 .11l.003 .085v6a1 1 0 0 1 -1 1h-1.171a3.001 3.001 0 0 1 -5.658 0h-4.342a3.001 3.001 0 0 1 -5.658 0h-1.171a1 1 0 0 1 -1 -1v-11a2 2 0 0 1 2 -2zm-6 12a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m10 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m.434 -9h-3.434v3h5.234z", "key": "svg-0" }]];
const IconTruckFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "truck-filled", "TruckFilled", __iconNode);


//# sourceMappingURL=IconTruckFilled.mjs.map


/***/ }),

/***/ 77373:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconX; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M18 6l-12 12", "key": "svg-0" }], ["path", { "d": "M6 6l12 12", "key": "svg-1" }]];
const IconX = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "x", "X", __iconNode);


//# sourceMappingURL=IconX.mjs.map


/***/ })

}]);